'use strict';

(function () {
    $(document).off('.wizardbook');

    const self = Fotobook.book;

    // Определяем константы отдельно для того, чтобы дальше могли из использовать при объявлении свойств
    /** @namespace Fotobook.book */
    $.extend(self, {
        COMMAND_REMOVE: 'remove',
        TYPE_GFX: 0,
        TYPE_VECTOR: 1,
        FIGURE_TYPE: {
            ELLIPSE: 'ellipse',
            RECT: 'rect',
            POLYGON: 'polygon',
            PATH: 'path',
        },
        default_line_height: 125,
        default_font_size: 100,

        containerClass: 'page-container',
        'vector-effect': document.documentElement.style.vectorEffect !== undefined,
        // похоже, среди поддерживаемых браузеров не осталось таких, которые не поддерживают foreignObject
        foreignObject: SVGForeignObjectElement !== undefined,

        container_classes: {
            [Fotobook.ContainerType.FOTO]: 'foto-container',
            [Fotobook.ContainerType.ARTEFACT]: 'artefact-container',
            [Fotobook.ContainerType.CALENDAR]: 'calendar-container',
            [Fotobook.ContainerType.CAPTION]: 'text-container',
            [Fotobook.ContainerType.GROUP]: 'group-container',
        },
        _removeContainerStings: {
            [Fotobook.ContainerType.ARTEFACT]: 'photobook-js-artefactDialogText',
            [Fotobook.ContainerType.BG]: 'photobook-js-removeBackground-dialogText',
            [Fotobook.ContainerType.CALENDAR]: 'photobook-js-removeCalendar-dialogText',
            [Fotobook.ContainerType.CAPTION]: 'photobook-js-rmTextContainerDialogTitle',
            [Fotobook.ContainerType.FOTO]: 'photobook-js-removeContainer-dialogText',
            [Fotobook.ContainerType.GROUP]: 'photobook-js-removeGroupContainer-dialogText',
        },
        zindex: {
            containerEditor: 201,
            container_max: 300,
            dragging: 301,
            ModalDialog: 10000,
        },
    });

    /** @namespace Fotobook.book */
    $.extend(Fotobook.book, {
        tab: '.ui-tabs-panel:visible',
        book: '#book',
        leftPage: '.book-page.left',
        rightPage: '.book-page.right',
        pagesList: '.carousel-pages-list',

        imageContainers: '.foto-container',
        select_bg_filter: ':not(.flyleaf-page):not(.cover)', // для фильтрования страниц, на которых нельзя просто так поменять фон
        select_foto_bg_filter: ':not(.flyleaf-page)', // для фильтрования страниц, на которых нельзя ставить фото на фон
        current: 0,
        pages_spread: false,
        covers_spread: false,

        /** режми одностраничного просмотра */
        single_page_mode: false,
        pagesFontSize: null,
        inited: false,
        pgCarouselStart: 1,
        isModified: false,
        spineWidth: 0,
        albums: [],
        bookbind: {},
        cover: {},
        cover_style: {},
        coverSet: 0,
        // currentPage: null, // видимо, не используется
        currentSpread: [],
        flyleaf: {},
        flyleafStyle: {},
        material: {},
        pages: {},
        prices: {},
        project: {},
        options: [],
        product: {},
        product_type: {},
        ratio: {},
        size: {},
        theme: {},
        themes: null,
        edit_mode: Fotobook.EditModeCode.CUSTOM,
        theme_settings: {},
        fonts: {},
        fallback_fonts: {
            'sans-serif': 1,
            serif: 1,
            cursive: 1,
            fantasy: 1,
        },
        undoDisabled: true,
        redoDisabled: true,
        _crop_attrs: ['crop_cx', 'crop_cy', 'crop_width', 'crop_height'],
        unique_id: 1,

        imagesUpdateTimer: 0,
        _containerBorderDragHandle: [
            '<div class="drag-handle t"></div>',
            '<div class="drag-handle l"></div>',
            '<div class="drag-handle r"></div>',
            '<div class="drag-handle b"></div>',
        ].join(""),
        BASE_SIZE: 14, // Должно равняться фонт-сайзу для родителя #book !!! это же число должно быть в variables.less !!!
        getCurrentFontSize() {
            let book;
            if (this instanceof jQuery || this instanceof Element) {
                book = $(this).closest('#book,#book-preview,.book');
            } else {
                book = $('#book:visible,#book-preview:visible');
            }
            return parseFloat(book.css('font-size'));
        },
        getUniqueId() {
            return `unique-id-${Fotobook.book.unique_id++}`;
        },
        getFotoPath(foto) {
            if (!foto || !foto.preview_path) {
                return '';
            }
            return Fotobook.createStorageUrl([foto.preview_path.replace(/\?version=.*/g, ''), '?version=', parseInt(foto.version, 10) || 0].join(''));
        },
        setBookbind(bookbind) {
            if (!bookbind) {
                return;
            }

            this.bookbind = bookbind;
            this.bookbind.binding_area = parseFloat(this.bookbind.binding_area);
            $('html')
                .toggleClass('bookbind-has-spine', this.bookbind.spine !== Fotobook.SpineType.NONE)
                .toggleClass('bookbind-text-spine', this.bookbind.spine === Fotobook.SpineType.TEXT)
                .attr('data-bookbind-type', this.bookbind.type)
            ;
            $(document).triggerHandler(Fotobook.events.BOOKBIND_CHANGED, this.bookbind);
        },
        setCover(cover) {
            if (!cover) {
                return;
            }
            Fotobook.book.cover = cover;

            $('html')
                .toggleClass('foto-clipart', Boolean(Fotobook.book.cover && Fotobook.book.cover.foto_clipart))
                .toggleClass('no-foto-clipart', !(Fotobook.book.cover && Fotobook.book.cover.foto_clipart))
                .toggleClass('foto-layout', Boolean(Fotobook.book.cover && Fotobook.book.cover.foto_layout))
                .toggleClass('no-foto-layout', !(Fotobook.book.cover && Fotobook.book.cover.foto_layout))
                .toggleClass('cover-has-spine', Boolean(Fotobook.book.cover && Fotobook.book.cover.spine !== Fotobook.SpineType.NONE))
                .toggleClass('cover-text-spine', Boolean(Fotobook.book.cover && Fotobook.book.cover.spine === Fotobook.SpineType.TEXT))
            ;
        },

        /** установить параметры  типа формата */
        setRatio(ratio) {
            if (ratio) {
                Fotobook.book.ratio = ratio;
            }
        },

        setModified(modified) {
            this.isModified = Boolean(modified);
        },

        // 26.09.2017 - Использовать по коду вместо прямого обращения к this.isModified
        getModified() {
            return this.isModified;
        },

        getProjectLocale() {
            return Fotobook.projectLanguages.get(this.project.language_id).code;
        },
        _option_tpl: '<option class="{class}" value="{val}" {selected} {disabled}>{text}</option>',
        createAlbumOptionsList(albums, selectedIds = [], disabledIds = []) {
            const options = [];
            const indentItem = '&nbsp;&nbsp;&nbsp;&nbsp;';
            let prev = null;
            let indent = '';
            let markedAlbum = Fotobook.getMarkedAlbum();

            for (let i = 0; i < albums.length; i++) {
                const album = albums[i];
                let selected = false;
                let disabled = false;
                if (!album.parent_id || !prev) {
                    indent = '';
                } else if (prev.parent_id !== album.parent_id) {
                    indent += indentItem;
                }
                // переделать хранение текущего альбома, чтобы избавиться от этого костыля
                if (selectedIds.length || disabledIds.length) {
                    selected = selectedIds.indexOf(album.id) > -1;
                    disabled = disabledIds.indexOf(album.id) > -1;
                } else {
                    selected = album.current;
                    disabled = false;
                }
                prev = album;
                options.push(this._option_tpl.supplant({
                    val: album.id,
                    text: indent + album.name.escapeHtml(),
                    selected: selected ? 'selected' : '',
                    disabled: disabled ? 'disabled' : '',
                    'class': markedAlbum && markedAlbum.id === album.id ? 'marked-album' : '',
                }));
            }
            return options;
        },
        updateAlbumsSelect() {
            const options = this.createAlbumOptionsList(this.albums);
            const $albumsSelect = $('#albums');
            $albumsSelect.html(options.join(''));
            return $albumsSelect.val();
        },
        createAlbumTree(tree, albums, parentId = null) {
            // деструктуризация - временный фикс, чтобы избежать мутации объекта, который хранится в vuex
            const sortedAlbums = [...albums];
            if (!parentId) {
                this.sortAlbums(sortedAlbums);
            }
            for (let i = 0, l = sortedAlbums.length; i < l; i++) {
                if (parentId === sortedAlbums[i].parent_id) {
                    tree.push(sortedAlbums[i]);
                    this.createAlbumTree(tree, sortedAlbums, sortedAlbums[i].id);
                }
            }
        },
        sortAlbums(albums) {
            albums.sort((a, b) => a.name.strnatcmp(b.name));
            return albums;
        },
        setAlbums(albums) {
            this.albums = [];
            this.createAlbumTree(this.albums, albums);
            return Fotobook.book.updateAlbumsSelect();
        },
        setSize(size) {
            if (!size) {
                return;
            }
            Fotobook.book.size = size;
            $('html').toggleClass('size-changecount', size.sets.length > 1); //показывать/не показывать селект выбора фикс кол. стр.
        },
        setTheme(theme, clipartThemeUUID) {
            if (!theme) {
                return;
            }
            if (clipartThemeUUID === undefined || clipartThemeUUID === null && !Fotobook.config.data[Fotobook.Settings.CLIPART_THEME_ALL_ENABLED]) {
                clipartThemeUUID = theme.uuid;
            }
            Fotobook.store.dispatch('onlineEditorMenu/setClipartThemeUUID', clipartThemeUUID);
            Fotobook.book.theme = theme;
        },

        setSpreadClasses(state) {
            if (!state) {
                return;
            }

            const $html = $(document.documentElement);
            if (state.pages_spread !== undefined) {
                this.pages_spread = Boolean(state.pages_spread);
                $html.toggleClass('pages-spread', this.pages_spread).toggleClass('pages-separate', !this.pages_spread);
            }

            if (state.covers_spread !== undefined) {
                this.covers_spread = Boolean(state.covers_spread);
                $html.toggleClass('covers-spread', this.covers_spread).toggleClass('covers-separate', !this.covers_spread);
            }
        },

        setSpineWidth(spineWidth) {
            if (spineWidth === undefined) {
                return;
            }
            Fotobook.book.spineWidth = parseFloat(spineWidth);
        },

        setCoverStyle(coverStyle) {
            Fotobook.book.cover_style = coverStyle || {};
        },

        setFonts(fonts) {
            this.fonts = fonts || {};
        },

        /**
         * добавить класс для блокирования контролов редактора
         *
         * @param project свойства проекта
         */
        setProjectInfo(project) {
            const oldProject = self.project;

            self.project = project;
            $(document.documentElement).toggleClass('project-options-locked', Boolean(!self.project || self.project.is_default_config));
            $(document).triggerHandler(Fotobook.events.PROJECT_INFO_CHANGED, [self.project, oldProject]);
        },
        isVerticalBookbind(position) {
            if (position === undefined) {
                position = this.product.has_bookbind;
            }
            return [Fotobook.BookbindPosition.LEFT_RIGHT, Fotobook.BookbindPosition.LEFT, Fotobook.BookbindPosition.RIGHT].includes(position);
        },
        isHorizontalBookbind(position) {
            if (position === undefined) {
                position = this.product.has_bookbind;
            }
            return [Fotobook.BookbindPosition.TOP, Fotobook.BookbindPosition.BOTTOM, Fotobook.BookbindPosition.TOP_BOTTOM].includes(position);
        },
        setOptions(options) {
            if (options) {
                this.options = Object.values(options);
            }
        },
        setProduct(product) {
            this.product = product;
            $(document.documentElement)
                .toggleClass('spread_shadow', !!this.product.spread_shadow)
                .toggleClass('h-bookbind-none', product.has_bookbind === Fotobook.BookbindPosition.NONE)
                .toggleClass('h-bookbind-left-right', product.has_bookbind === Fotobook.BookbindPosition.LEFT_RIGHT)
                .toggleClass('h-bookbind-right', product.has_bookbind === Fotobook.BookbindPosition.RIGHT)
                .toggleClass('h-bookbind-left', product.has_bookbind === Fotobook.BookbindPosition.LEFT)
                .toggleClass('h-bookbind-top', product.has_bookbind === Fotobook.BookbindPosition.TOP)
                .toggleClass('h-bookbind-vertical', this.isVerticalBookbind())
                .toggleClass('h-bookbind-horizontal', this.isHorizontalBookbind())
            ;
        },

        /** установить информацию о типе продукта */
        setProductType(productType) {
            if (productType) {
                Fotobook.book.product_type = productType;
            }
        },

        /** установить признак одностраничности продукта
         *
         * @param {object} product
         * @returns {boolean}
         * @private
         */
        _isSinglePageMode(product) {
            if (product.pages_spread_count === 1 || $('html').hasClass('single-page-mode')) {
                return true;
            } else if (product.pages_spread_count === 2) {
                return false;
            } else {
                throw 'Invalid number of pages';
            }
        },

        updateUndoRedoButtons(data) {
            if (data.undoDisabled !== undefined) {
                this.undoDisabled = data.undoDisabled;
            }
            if (data.redoDisabled !== undefined) {
                this.redoDisabled = data.redoDisabled;
            }
        },
        /** установить значения переменных проекта */
        setProjectVariables(state) {
            Fotobook.book.setProductType(state.productType);
            Fotobook.book.setProjectInfo(state.project);
            Fotobook.book.setSpreadClasses(state);
            Fotobook.book.setSize(state.size);
            Fotobook.book.setRatio(state.ratio);
            Fotobook.book.setBookbind(state.bookbind);
            Fotobook.book.setCover(state.cover);
            this.material = state.page_material;
            Fotobook.book.setTheme(state.theme, state.clipart_theme_uuid);
            if (state.theme_settings !== undefined) {
                Fotobook.book.theme_settings = state.theme_settings;
            }
            Fotobook.book.setCoverStyle(state.cover_style);
            Fotobook.book.setProduct(state.product);
            Fotobook.book.setFonts(state.theme_fonts);
            Fotobook.book.setSpineWidth(state.spineWidth);
            Fotobook.book.setAlbums(state.albums);
            Fotobook.book.single_page_mode = self._isSinglePageMode(state.product);

            // нужно пересмотреть и сделать единую мутацию для данных редактора
            Fotobook.store.commit('OnlineEditor/setPages', state.pages);
            Fotobook.store.commit('ProjectState/setHolidayListsBinding', state.holidayListsBinding);
            Fotobook.store.commit('ProjectState/setUserHolidays', state.userHolidays);

            Fotobook.displayRegions.recalc();
            this.prices = state.prices;
            this.coverSet = state.coverSet;
            this.flyleaf = state.flyleaf || {};
            this.flyleafStyle = state.flyleaf_style || {};
            this.updateUndoRedoButtons(state);
            this.setOptions(state.adOptions);
        },

        initState(response) {
            if (!response?.state) {
                throw new Error('No init data');
            }
            const state = response.state;
            Fotobook.store.commit('Fonts/clearLoadedFonts');

            Fotobook.store.commit('OnlineEditor/setHolidayLists', response.holidayLists || []);
            Fotobook.book.setProjectVariables(state);
            Fotobook.book.pagesInit(state);

            // @todo Реализовать через инициализацию компонентов
            $(document).trigger('resize');
            $(document).triggerHandler(Fotobook.events.PROJECT_CONTENT_CHANGED);
        },

        getPagePixelK($page) {
            const size = $page.computedSize();
            const vertical = !this.isHorizontalBookbind();
            return parseFloat($page.attr(vertical ? 'data-page-width' : 'data-page-height')) / size[vertical ? 'width' : 'height'];
        },

        getMinPagesCount() {
            if (Fotobook.book.size.changecount && Fotobook.book.size.sets && Fotobook.book.size.sets.length) {
                return Fotobook.book.size.sets[0];
            }
            return Fotobook.book.size.min_pages_count;
        },

        getPagesCount() {
            const pages = Fotobook.store.state.OnlineEditor.pages;
            return Object.values(pages).filter((page) => page.type === Fotobook.PageType.PAGE).length;
        },
        getMultiplicityPagesCount() {
            const types = ['.page'];
            if (Fotobook.book.size.count_covers) {
                types.push('.cover');
            }
            return $(Fotobook.book.pagesList).find('.book-page').filter(types.join(',')).length;
        },

        getPxToEmK() {
            const $page = $(this).closest('.book-page');
            const dx = parseFloat($page.attr('data-dx'));
            const k = parseFloat($page.attr('data-page-width')) / $page.width();
            return k * dx;
        },

        /**
         * Конвертирование PX -> EM
         * @param px {number}
         * @returns {string} 100em
         */
        pxToEm(px) {
            return Fotobook.book.getSizeInEm(px * Fotobook.book.getPxToEmK.call(this));
        },

        /**
         * Получить объект jQuery текущего разворота
         * @returns {jQuery}
         */
        getCurrentSpread() {
            return $(Fotobook.book.pagesList).children('.selected').find('.book');
        },

        /**
         * Получить jQuery объект текущей страницы
         * @returns {jQuery}
         */
        getCurrentPage() {
            return Fotobook.book.getPageByPageNum(
                Fotobook.store.getters['OnlineEditor/currentPage']
            );
        },

        getPageByPageNum(pageNum) {
            return $(this.pagesList).find(`.page_num_${pageNum}`);
        },
        getPageById(id) {
            return $(this.pagesList).find(`.page_${id}`);
        },
        getAdjacentPage($page) {
            $page = $page.closest('.book-page');
            let pageNum = Number($page.attr('data-page_num'));
            let left;
            if ($page.hasClass('left')) {
                left = true;
            } else if ($page.hasClass('right')) {
                left = false;
            } else {
                return $();
            }
            if (left) {
                pageNum++;
            } else {
                if (pageNum <= Fotobook.book.product.covers_count && $page.hasClass('page')) {
                    return $();
                } else {
                    pageNum--;
                }
            }
            return Fotobook.book.getPageByPageNum(pageNum);
        },
        getAdjacentBg($bg) {
            return Fotobook.book.getAdjacentPage($bg).find('.bg-content');
        },
        getSortedCovers() {
            return $.makeArray($(Fotobook.book.pagesList).find('.book-page.cover')).sort((a, b) => {
                return parseInt(a.getAttribute('data-page_num'), 10) - parseInt(b.getAttribute('data-page_num'), 10);
            });
        },
        /**
         * Получить массив страниц в нужном порядке облжки, страницы
         * @returns {Array.<T>|*|{options, browsertest, dist, rhino, rhinolessc}|string|{options, bootstrap}}
         */
        getSortedPagesArray() {
            return Fotobook.book.getSortedCovers().concat($.makeArray($(Fotobook.book.pagesList).find('.book-page:not(.cover)')));
        },

        getPageNumFromSpread(spread) {
            const $pages = $(spread).find('.book-page');
            let $page = $pages.filter(':not(.flyleaf-page)');

            if (!$page.length) {
                $page = $pages.filter('.flyleaf-page');
            }
            if ($page.hasClass('cover')) {
                $page = $page.last();
            } else {
                $page = $page.first();
            }
            return Number($page.attr('data-page_num')) || 0;
        },
        /**
         * Возвращает страницу по координате x
         * @param {float} x      - координата X, по которой берётся страница (её достаточно, по вертикали страница только одна)
         * @param closest {boolean} - позволяет получить страниц, ближайшую по x, даже если координата не точно над страницей
         */
        getPageByPixel(x, closest) {
            let $page;
            let distance = Infinity;
            $(Fotobook.book.book).find('.book-page').each(function () {
                const $this = $(this);
                const boundingRect = this.getBoundingClientRect();
                let left = boundingRect.left;
                let right = boundingRect.right;

                if ($this.hasClass('left')) {
                    right += parseFloat($this.css('marginRight'));
                } else if ($this.hasClass('right')) {
                    left -= parseFloat($this.css('marginLeft'));
                }
                if (closest) {
                    const currentDistance = Math.abs((right + left) / 2 - x);
                    if (currentDistance < distance) {
                        distance = currentDistance;
                        $page = $this;
                    }
                } else if (x >= left && x <= right) {
                    $page = $this;
                    return false;
                }
                return null;
            });
            return $page;
        },
        getClosestPageByPixel(x) {
            return Fotobook.book.getPageByPixel(x, true);
        },

        /**
         * возвращает полные размеры страницы (с зоной переплёта) но без учёта корешка! (вероятно, доделать в будущем!)
         * todo Пока - затычка для форзацев. В будущем подумать, что с этим сделать
         */
        getFullPageSize(pageType) {
            const displayRegion = Fotobook.displayRegions.getRegion([pageType, Fotobook.PageType.PAGE], true);
            return {
                width: displayRegion.width + displayRegion.bindingAreaSize.width,
                height: displayRegion.height + displayRegion.bindingAreaSize.height,
            };
        },

        getSelectionWidget() {
            return $(Fotobook.book.book).find('.pages-wrapper').data('fotobook-containerEditor');
        },
    /*
    // @todo check maybe not used
        splitFontFamily(family) {
            var fonts = (family || '').toLowerCase().split(",");
            for (var i = 0, l = fonts.length; i < l; i++) {
                fonts[i] = fonts[i].replace(/^[\s\"']+|[\s\"']+$/g, '');
            }
            return fonts;
        },
    */
        getBaseFontSize() {
            return parseFloat(Fotobook.book.theme_settings.caption_font_size) || Fotobook.book.default_font_size;
        },
        isBgSpread($el) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }

            let $wrapper;
            let $page;
            if ($el.hasClass('pages-wrapper')) {
                $page = $el.find('.book-page').first();
                $wrapper = $el;
            } else {
                $page = $el.closest('.book-page');
                $wrapper = $page.closest('.pages-wrapper');
            }

            const $page2 = Fotobook.book.getAdjacentPage($page);
            const $img1 = $page.find('.bg-content').find('.bg-clipart');
            const $img2 = $page2.find('.bg-content').find('.bg-clipart');

            let spread = false;
            if ($img1.length && $img2.length) {
                if ($img1.hasClass('bg-clipart-foto-half') && $img2.hasClass('bg-clipart-foto-half') && ($img1.attr('data-id') === $img2.attr('data-id'))) {
                    spread = true;
                } else if (!$img1.hasClass('bg-clipart-foto') && !$img2.hasClass('bg-clipart-foto') && ($wrapper.hasClass('cover') ? Fotobook.book.covers_spread : Fotobook.book.pages_spread)) {
                    spread = true;
                }
            }
            return spread;
        },
        getSingleOrSpreadBg($el) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            const wrapper = $el.closest('.pages-wrapper');
            if (wrapper.hasClass('bg-spread')) {
                return wrapper.find('.bg');
            }
            return $el.closest('.bg');
        },
        markEmptyCaption($el) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            $el = $el.closest('.text-container');

            $el.each(function () {
                const $container = $(this);
                const $content = $container.find('.text-content');
                $container.toggleClass('empty-caption', Fotobook.book.isEmptyCaption($content));
            });
        },
        isEmptyCaption($content) {
            return !($content.find('table').length || $.trim($content.text()).length);
        },
        removeContainer($container) {
            if ((typeof $container == 'number') || (typeof $container == 'string')) {
                $container = $(Fotobook.book.getContainerSelector($container));
            }
            if (!($container instanceof jQuery)) {
                $container = $($container);
            }
            $container.each(function () {
                let $this = $(this).attr('data-deleted', 1);

                if ($this.hasClass('top-level')) {
                    $this = $this.closest('.cont-wrapper');
                }
                $this.remove();
            });
        },
        /**
         *  Добавить контейнер на страницу
         *
         * @param container
         */
        addContainerToPage(container) {
            const $page = $(`.page_${container.page_id}`);
            const dX = parseFloat($page.attr('data-dx'));
            const region = $page.attr('data-page_type');
            const content = this.drawContainer(container, dX, region);

            $page.find('.append-containers').append(this.wrapContainer($.extend({
                content,
            }, this.getContainerWrapData($page))));
            $(document).triggerHandler(Fotobook.events.CONTAINER_ADDED, container.id);
        },
        matrix_transform(m, x, y) {
            return {
                x: x * m[0] + y * m[2],
                y: x * m[1] + y * m[3],
            };
        },
        getRotationMatrix(a) {
            a = a.toRad();
            return [Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a)];
        },
        normalizeAngle(angle) {
            return Fotobook.angles.normalizeAngle(parseFloat(angle) || 0);
        },
        // webkit: если общая ширина элемента нецелая, может пропадать правая граница
        chromeFixCarouselPageWidth() {
            if ($.browser.webkit) {
                $(`${Fotobook.book.pagesList}:visible`).find('.book').each(function () {
                    const $this = $(this);
                    $this.css('width', '').css('width', $this.css('width'));
                });
            }
        },

        /**
         * Инициализация страниц проекта
         * @param state {object}
         */
        pagesInit(state) {
            // @todo проверить поведение. на бекенде целый компонент (CurrentPageBehavior) отвечает за расчет текущей страницы
            Fotobook.store.dispatch('OnlineEditor/setCurrentPage', Math.min(state.currentPage, Object.keys(state.pages).length - 1));
            Fotobook.book.drawPages(state.pages);
            Fotobook.book.appendSpine(state.spine);
            Fotobook.book.drawCurrent();
            Fotobook.flyleafStyle.update();
            Fotobook.book.inited = true;
            Fotobook.book.chromeFixCarouselPageWidth();
        },

        fillPageChunks(pages, singlePageMode = Fotobook.book.single_page_mode) {
            let chunks = [];
            let covers = [];

            // пока что хардкод
            if ([Fotobook.BookbindPosition.LEFT_RIGHT, Fotobook.BookbindPosition.TOP_BOTTOM].indexOf(this.product.has_bookbind) === -1) {
                singlePageMode = true;
            }
            while (pages.length) {
                const page = pages.shift();
                if (page && (page instanceof Element ? page.classList.contains('cover') : page.type === Fotobook.PageType.COVER)) {
                    covers.push(page);
                } else if (Fotobook.book.product.pages_spread_count === 1 || singlePageMode && !Fotobook.book.pages_spread) {
                    chunks.push([page]);
                } else {
                    chunks.push([page, pages.shift()]);
                }
            }
            if (covers.length) {
                // пока хардкодим 2
                if (Fotobook.book.product.covers_count === 2 && singlePageMode && !Fotobook.book.covers_spread) {
                    chunks.push([covers.shift()]);
                    chunks.unshift([covers.shift()]);
                } else {
                    chunks.unshift(covers);
                }
            }

            return chunks;
        },

        preparePageChunks(statePages) {
            const coversCount = Fotobook.book.product.covers_count;
            const flyleaves = new Array(Fotobook.book.product.flyleaves_count).fill(null);
            let pages = Object.values(statePages);

            // Кривой хром при декодировании json меняет порядок свойств у объекта :(
            // https://bugs.chromium.org/p/v8/issues/detail?id=164
            pages.sort((a, b) => a.page_num - b.page_num);
            pages = pages.slice(0, coversCount).concat(flyleaves).concat(pages.slice(coversCount)).concat(flyleaves);
            return Fotobook.book.fillPageChunks(pages);
        },
        _carouselItemPageTpl: [
            '<li class="carousel-item coloured-border">',
                '<div class="book-errors core-text-11">',
                    '<div class="cont-warning cont-warning-empty-cont ajax-tooltip" data-qtip-selector="photobook-tooltipText-contWarning-empty"><div class="cont-warning-bg oe-sprite-image"></div><div class="warning-counter">1</div></div>',
                    '<div class="cont-warning cont-warning-no-orig ajax-tooltip" data-qtip-selector="photobook-tooltipText-contWarning-noOrig"><div class="cont-warning-bg oe-sprite-image"></div><div class="warning-counter">1</div></div>',
                    '<div class="cont-warning cont-warning-low-quality ajax-tooltip" data-qtip-selector="photobook-tooltipText-contWarning-lowQuality"><div class="cont-warning-bg oe-sprite-image"></div><div class="warning-counter">1</div></div>',
                    '<div class="cont-warning cont-warning-others ajax-tooltip" data-qtip-selector="photobook-tooltipText-contWarning-others"><div class="cont-warning-bg oe-sprite-image"></div><div class="warning-counter">1</div></div>',
                    '<div class="show-page-errors-link cont-warning-right"><a href="#">', window.t('photobook-js-bookError-showPageErrorsLink'), '</a></div>',
                '</div>',
                '<div class="book selectable coloured-border">',
                    '<div class="pages-wrapper" style="height:{height}">',
                        '{pages}',
                    '</div>',
                    '<div class="marker"></div>',
                '</div>',
                '<div class="page_num core-text-11"></div>',
            '</li>',
        ].join(''),

        drawCarouselItems(chunks, dom) {
            var r = [],
                n = 0,
                flyleaf_page_num = 0,
                lr;
            for (let i = 0, l = chunks.length; i < l; i++) {
                const chunk = chunks[i];
                const pages = [];
                let coverWrapper = null;

                for (let j = 0, m = chunk.length; j < m; j++) {
                    var page = chunk[j];
                    if (coverWrapper === null && page) {
                        coverWrapper = (dom ? page.classList.contains('cover') : (page.type === Fotobook.PageType.COVER));
                    }
                    if (!page || dom && page.classList.contains('flyleaf-page')) {
                        flyleaf_page_num++;
                    }
                    if (dom) {
                        pages.push(page.outerSVG);
                    } else {
                        if (Fotobook.book.product.pages_spread_count === 2) {
                            if (!page) {
                                lr = flyleaf_page_num % 2 ? 'left' : 'right';
                            } else if (page.type === Fotobook.PageType.COVER) {
                                lr = page.page_num % 2 ? 'right' : 'left';
                            } else {
                                lr = (page.page_num + Fotobook.book.product.flyleaves_count) % 2 ? 'right' : 'left';
                            }
                        } else {
                            lr = '';
                        }
                        pages.push(Fotobook.book.drawPage({
                            page,
                            lr,
                            flyleaf_page_num: -flyleaf_page_num,
                        }));
                    }
                    n++;
                }
                const pageType = coverWrapper ? Fotobook.PageType.COVER : (page ? page.type : Fotobook.PageType.PAGE);
                r.push(Fotobook.book._carouselItemPageTpl.supplant({
                    pages: pages.join(''),
                    height: Fotobook.book.getSizeInEm(this.getFullPageSize(pageType).height),
                }));
            }
            return r.join('');
        },

        updateBgSpread($wrapper) {
            if (!($wrapper instanceof jQuery)) {
                $wrapper = $($wrapper);
            }
            const spread = this.isBgSpread($wrapper);
            const verticalSpread = this.isHorizontalBookbind();

            $wrapper.toggleClass('bg-spread', spread);
            $wrapper.find('.bg .mask-position').each(function () {
                if (spread) {
                    this.setAttribute(verticalSpread ? 'height' : 'width', '200%');
                    if ($(this).closest('.book-page').hasClass('page_odd')) {
                        this.setAttribute(verticalSpread ? 'y' : 'x', '-100%');
                    }
                } else {
                    this.removeAttribute('x');
                    if (this.nodeName === 'image') {
                        this.setAttribute(verticalSpread ? 'height' : 'width', '100%');
                    } else {
                        this.removeAttribute(verticalSpread ? 'height' : 'width');
                    }
                }
            });
        },
        updatePageWrapperClasses() {
            const $wrapper = $(this);
            $wrapper.toggleClass('cover', $wrapper.find('.book-page.cover').length > 0);
            $wrapper.toggleClass('page', $wrapper.find('.book-page.page').length > 0);
            $wrapper.toggleClass('flyleaf', $wrapper.find('.book-page.flyleaf-page').length > 0);
            Fotobook.book.updateBgSpread(this);
        },
        updateAllPageWrappersClasses($parent) {
            if (!$parent) {
                $parent = $(Fotobook.book.pagesList);
            }
            $parent.find('.pages-wrapper').each(Fotobook.book.updatePageWrapperClasses);
        },

        /**
         * Обновить содержимое карусели
         * @param content string html код страниц
         */
        replacePagesCarousel(content) {
            $(Fotobook.book.pagesList).html(content);

            Fotobook.store.dispatch('bottomPanel/recalcCarouselFontSize');
            // Fotobook.bottomPanel.recalcCarouselFontSize();

            Fotobook.book.updateAllPageWrappersClasses();

            Fotobook.store.dispatch('pagesPanel/updatePagesNames');
            // Fotobook.bottomPanel.pagesTab.updatePagesNames();
        },

        drawPages(pages) {
            const chunks = Fotobook.book.preparePageChunks(pages);
            const content = Fotobook.book.drawCarouselItems(chunks);
            Fotobook.book.replacePagesCarousel(content);
        },

        /**
         * Возвращает величину смещения для центровки содержимого по вертикали для случаев, когда фактическое соотношение сторон
         * в size отличается от идеального (ratio)
         *
         * @param page
         * @returns {number}
         */
        getCenterShift(page) {
            if (!page) {
                return 0;
            }
            const displayRegion = Fotobook.displayRegions.getRegion(page.type);

            if (!displayRegion) {
                return 0;
            }
            if (this.isHorizontalBookbind()) {
                return (displayRegion.width - page.width / page.height * displayRegion.height) / 2;
            }
            return (displayRegion.height - page.height / page.width * displayRegion.width) / 2;
        },

        getPageOddness(page, flyleafPageNum) {
            if (!page) {
                return Boolean(-(flyleafPageNum - 1) % this.product.pages_spread_count);
            }
            if (page.type === Fotobook.PageType.COVER) {
                return this.project.covers_count === 1 || page.page_num !== 0;
            }
            if (page.type === Fotobook.PageType.PAGE) {
                return Boolean((page.page_num - this.product.covers_count + this.product.flyleaves_count) % this.product.pages_spread_count);
            }

            return false;
        },

        preloadBackground(src) {
            const $body = $('body');
            let data = $body.data('fotobook-bg-preload');
            if (!data) {
                $body.data('fotobook-bg-preload', {});
            }
            data = $body.data('fotobook-bg-preload');
            if (!data[src]) {
                data[src] = true;
                setTimeout(() => {
                    const img = document.createElement('img');
                    img.classList.add('preload-image');
    // не удаляем, так как на загрузку из кеша уходит время, достаточное, что изображение моргнуло
                    img.setAttribute('src', src);
                    $('body').append(img);
                });
            }
        },
        setupBgBoundingRect() {
            var $box = this,
                $clip = $box.closest('.bg-clip'),
                $visible = $clip.find('.bg-cropping-visible'),
                css = {
                    left: $box.attr('data-visible-x'),
                    top: $box.attr('data-visible-y'),
                    width: $box.attr('data-visible-width'),
                    height: $box.attr('data-visible-height'),
                };
            if ($visible.length) {
                $visible.css(css);
            } else {
                $clip.append('<div class="bg-cropping-visible" style="position:absolute;left:{left};top:{top};width:{width};height:{height};"></div>'.supplant(css));
            }
        },

        /** Добавить верстку контролов для старницы и верску лоудера */
        setupPageBackground() {
            if (!this.closest('.flyleaf-page').length) {
                this.closest('.bg')
                    .prepend(Fotobook.book.fotoContainerControls_before)
                    .append([
                        Fotobook.ajaxLoaderMin,
                    ]);
                Fotobook.book.setupBgBoundingRect.call(this);
            }
        },

        _theme_bg_tmpl: `<image
            class="bg-image bg-clipart bg-clipart-theme set-opacity"
            x="{x}"
            y="{y}"
            width="{width}"
            height="{height}"
            xlink:href="{url}"
            data-id="{data-background-id}"
            data-width="{data-width}"
            data-height="{data-height}"
            data-x1="{data-x1}"
            data-y1="{data-y1}"
            data-x2="{data-x2}"
            data-y2="{data-y2}"
        />`,
        drawThemeBackground(page) {
            const pageType = page.type;
            const displayRegion = Fotobook.displayRegions.getRegion(pageType);
            const odd = this.getPageOddness(page);
            const isVerticalSpread = this.isHorizontalBookbind();
            const spineOffset = this.getPageSpine(page);
            const bgc = page.background;
            const bg = bgc.background;
            let url = '/images/spacer.gif';
            const centerShift = this.getCenterShift(page);
            const bindingData = this.getPageBinding(page);
            const coeff = isVerticalSpread ? displayRegion.height / (bg.y2 - bg.y1) : displayRegion.width / (bg.x2 - bg.x1);
            const width = bg.width * coeff;
            const height = bg.height * coeff;
            // левый фон, который выровнен по левой стороне, смещается на размер корешка, так как за счёт фона задней страницы корешок формируется
            // правый фон требует смещения на величину зоны переплёта
            let x = bg.x1 * coeff;
            let y = bg.y1 * coeff;

            if (isVerticalSpread) {
                y -= bindingData.top;
                if (!odd) {
                    y -= spineOffset.top;
                }
                x -= centerShift + bindingData.left;
            } else {
                x -= bindingData.left;
                if (!odd) {
                    x -= spineOffset.right;
                }
                y -= centerShift + bindingData.top;
            }

            if (bg.preview_path !== undefined) {
                url = Fotobook.createStorageUrl(`${bg.preview_path}?version=${bg.version || 0}`);
                Fotobook.book.preloadBackground(url);
                const arr = /preview\/(.+)/.exec(url);
                if (arr && arr[1]) {
                    url = url.replace(arr[1], `small_${arr[1]}`);
                }
            }

            return this._theme_bg_tmpl.supplant({
                url,
                id: bgc.id,
                width: Fotobook.book.getSizeInEm(width),
                height: Fotobook.book.getSizeInEm(height),
                x: Fotobook.book.getSizeInEm(-x),
                y: Fotobook.book.getSizeInEm(-y),
                'data-background-id': bg.id,
                'data-width': bg.width,
                'data-height': bg.height,
                'data-x1': bg.x1,
                'data-y1': bg.y1,
                'data-x2': bg.x2,
                'data-y2': bg.y2,
            });
        },
        getFotoBackgroundTransformOrigin(spread, verticalSpread, odd) {
            // если не разворот или переплёт по другой координате - крутим относительно центра координат
            // иначе, если разворот и переплёт по нашей координате, крутим относительно нужной стороны
            const transformOriginX = (!spread || verticalSpread) ? 'center' : (odd ? 'left' : 'right');
            const transformOriginY = (!spread || !verticalSpread) ? 'center' : (odd ? 'top' : 'bottom');
            return `${transformOriginX} ${transformOriginY}`;
        },
        getFotoBackgroundTransform(angle, x, y) {
            return `rotate(${angle}deg) translate(${x}, ${y})`;
        },
        _foto_bg_tpl: `
            <image
                class="bg-image bg-clipart bg-clipart-foto set-opacity {classes}"
                style="{fotoAngleCss}; transform: {transform}; transform-origin: {transformOrigin}"
                data-id="{foto_id}"
                width="{width}"
                height="{height}"
                xlink:href="{url}?v={v}"
                data-width="{data-width}"
                data-height="{data-height}"
                data-crop_cx="{data-crop_cx}"
                data-crop_cy="{data-crop_cy}"
                data-crop_height="{data-crop_height}"
                data-crop_width="{data-crop_width}"
                data-x1="{data-x1}"
                data-y1="{data-y1}"
                data-x2="{data-x2}"
                data-y2="{data-y2}"
                data-foto_position="{data-foto_position}"
            />
            <rect
                class="bounding-box"
                x="{bbox_x}"
                y="{bbox_y}"
                width="{bbox_width}"
                height="{bbox_height}"
                fill="url(#no-original-pattern)"
                mask="url(#no-original-mask)"
                data-visible-x="{vbox_x}"
                data-visible-y="{vbox_y}"
                data-visible-width="{vbox_width}"
                data-visible-height="{vbox_height}"
            />
        `,
        getFotoBgCroppingAttrs(data) {
            const cropping = Fotobook.book.getFotoCroppingSizes({
                angle: data.angle,
                foto_width: data.foto_width,
                foto_height: data.foto_height,
                crop_cx: data.crop_cx || 50,
                crop_cy: data.crop_cy || 50,
                crop_width: data.crop_width || 100,
                crop_height: data.crop_height || 100,
                cont_width: data.cont_width,
                cont_height: data.cont_height,
            });
            const sizeCoeff = cropping.image_width / data.foto_width;

            cropping.x = cropping.image_width * data.crop_cx / 100 - data.center_x;
            cropping.y = cropping.image_height * data.crop_cy / 100 - data.center_y;
            cropping.x1 = cropping.x / sizeCoeff;
            cropping.y1 = cropping.y / sizeCoeff;
            cropping.x2 = cropping.x1 + data.visible_w / sizeCoeff;
            cropping.y2 = cropping.y1 + data.visible_h / sizeCoeff;

            return cropping;
        },
        drawFotoBackground(page) {
            const pageType = page.type;
            const odd = this.getPageOddness(page);
            const bgc = page.background;
            const foto = bgc.foto;
            const displayRegion = Fotobook.displayRegions.getRegion(pageType);
            const pageW = displayRegion.width;
            const pageH = displayRegion.height;
            const bleed = displayRegion.bleed_box;
            const spread = bgc.foto_position === Fotobook.FotoPosition.HALF;
            const verticalSpread = this.isHorizontalBookbind();
            const binding = this.getPageBinding(page);
            const spine = this.getPageSpine(page.type);
            const classes = [];
            const visibleBgW = pageW + binding.left + binding.right + spine.left + spine.right;
            const visibleBgH = pageH + binding.top + binding.bottom + spine.top + spine.bottom;

            let visibleW;
            let visibleH;
            if (verticalSpread) {
                visibleW = visibleBgW;
            } else {
                visibleH = visibleBgH;
            }
            if (spread) {
                if (verticalSpread) {
                    visibleH = 2 * (pageH + binding.top + binding.bottom) + spine.top + spine.bottom;
                } else {
                    visibleW = 2 * (pageW + binding.left + binding.right) + spine.left + spine.right;
                }
            } else {
                if (verticalSpread) {
                    visibleH = pageH + binding.top + binding.bottom + (odd ? 0 : spine.top + spine.bottom);
                } else {
                    visibleW = pageW + binding.left + binding.right + (odd ? 0 : spine.left + spine.right);
                }
            }

            const fullW = 2 * bleed + visibleW;
            const fullH = 2 * bleed + visibleH;
            let centerX = visibleW / 2;
            let centerY = visibleH / 2;
            if (spread && odd) {
                if (verticalSpread) {
                    centerY = -(spine.top + spine.bottom) / 2;
                } else {
                    centerX = -(spine.left + spine.right) / 2;
                }
            }

            const cropping = this.getFotoBgCroppingAttrs({
                angle: foto.angle,
                foto_width: foto.width,
                foto_height: foto.height,
                crop_width: bgc.crop_width,
                crop_height: bgc.crop_height,
                cont_width: fullW,
                cont_height: fullH,
                visible_w: visibleBgW,
                visible_h: visibleBgH,
                crop_cx: bgc.crop_cx,
                crop_cy: bgc.crop_cy,
                center_x: centerX,
                center_y: centerY,
            });
            if (spread) {
                classes.push('bg-clipart-foto-half');
            }

            return Fotobook.book._foto_bg_tpl.supplant({
                foto_id: foto.id,
                url: Fotobook.createStorageUrl(foto.preview_path),
                classes: classes.join(' '),
                v: foto.version,
                width: Fotobook.book.getSizeInEm(cropping.image_width),
                height: Fotobook.book.getSizeInEm(cropping.image_height),
                fotoAngleCss: this.styleToString(this.getFotoAngleVars(foto.angle)),
                'data-width': foto.width,
                'data-height': foto.height,
                'data-x1': cropping.x1,
                'data-x2': cropping.x2,
                'data-y1': cropping.y1,
                'data-y2': cropping.y2,
                'data-crop_cx': bgc.crop_cx,
                'data-crop_cy': bgc.crop_cy,
                'data-crop_width': bgc.crop_width,
                'data-crop_height': bgc.crop_height,
                'data-foto_position': bgc.foto_position,
                bbox_x: Fotobook.book.getSizeInEm(centerX - fullW / 2),
                bbox_y: Fotobook.book.getSizeInEm(centerY - fullH / 2),
                bbox_width: Fotobook.book.getSizeInEm(fullW),
                bbox_height: Fotobook.book.getSizeInEm(fullH),
                vbox_x: Fotobook.book.getSizeInEm(centerX - visibleW / 2),
                vbox_y: Fotobook.book.getSizeInEm(centerY - visibleH / 2),
                vbox_width: Fotobook.book.getSizeInEm(visibleW),
                vbox_height: Fotobook.book.getSizeInEm(visibleH),
                // rotate({fotoAngle}deg) translate({x}, {y}); transform-origin: {transformOriginX} {transformOriginY}
                transform: this.getFotoBackgroundTransform(
                    foto.angle,
                    Fotobook.book.getSizeInEm(-cropping.x),
                    Fotobook.book.getSizeInEm(-cropping.y)
                ),
                transformOrigin: this.getFotoBackgroundTransformOrigin(spread, verticalSpread, odd),
            });
        },
        drawPageBackgroundImage(page) {
            const bgc = page.background;

            if (!bgc) {
                return '';
            }

            let bg = '';
            if (bgc.foto && bgc.foto.id) {
                bg = Fotobook.book.drawFotoBackground(page);
            } else if (bgc.background && bgc.background.id) {
                bg = Fotobook.book.drawThemeBackground(page);
            }
            return bg;
        },
        _clipart_bg_tpl:
        `<div
            class="cont_{id} bg-content {bg-content-classes}"
            data-container-type="${Fotobook.ContainerType.BG}"
            data-id="{id}"
            style="--container-opacity: {opacity};"
        >
            <div class="bg-clip">
                <svg version="1.1" width="100%" height="100%" overflow="visible">
                    <defs class="defs">
                        {mask}
                    </defs>
                    <g class="apply-mask" {mask-attr}>
                        {bg}
                    </g>
                </svg>
            </div>
        </div>`,
        drawClipartBackground(page) {
            var bg = this.drawPageBackgroundImage(page),
                bgc = page.background,
                foto = bgc.foto,
                mask = this.drawMask(bgc),
                maskAttr = mask ? 'mask="url(#{mask-svg-id})"' : '',
                classes = [];

            if (foto && !foto.originalExists) {
                classes.push('no-original');
                // todo перенести на события!!!
                if (Fotobook.import.isUploadingNow(Fotobook.ClipartType.FOTO, foto.id)) {
                    classes.push('uploading');
                }
            }
            let r = this._clipart_bg_tpl.supplant({
                bg,
                mask,
                id: bgc.id,
                'mask-attr': maskAttr,
                opacity: bgc.opacity / 100,
                'bg-content-classes': classes.join(' '),
            });
            if (mask) {
                r = r.supplant({
                    'mask-svg-id': this.getUniqueId(),
                });
            }
            return r;
        },
        _style_bg_tmpl: [
            '<svg version="1.1" x="0" y="0" width="100%" height="100%" style="overflow:hidden">',
                '<image class="bg-content bg-image bg-style" x="-1%" y="-1%" width="102%" height="102%" xlink:href="{style_bg_url}" preserveAspectRatio="xMidYMid slice" />',
            '</svg>',
        ].join(''),
        drawStyleBackground(page) {
            const style_bg_url = page ? Fotobook.createStorageUrl(Fotobook.book.cover_style.preview_path) : '';
            return Fotobook.book._style_bg_tmpl.supplant({
                style_bg_url,
            });
        },
        drawPageBackground(page) {
            if (page && (page.type !== Fotobook.PageType.COVER || Fotobook.book.cover.foto_clipart)) {
                return Fotobook.book.drawClipartBackground(page);
            }
            return Fotobook.book.drawStyleBackground(page);
        },

        styleToString(style) {
            return Object.entries(style).map(([name, value]) => `${name}:${value}`).join(';');
        },
        getAngleVars(angle, angleVar, transformVar, transformReverseVar) {
            const normalizedAngle = Fotobook.angles.normalizeAngle(angle);
            return {
                [angleVar]: normalizedAngle,
                [transformVar]: `rotate(${normalizedAngle}deg)`,
                [transformReverseVar]: `rotate(${-normalizedAngle}deg)`,
            };
        },
        getContainerAngleVars(angle) {
            return this.getAngleVars(angle, '--container-angle', '--container-angle-t', '--container-angle-tr');
        },
        getContainerFotoAngleVars(angle) {
            return this.getAngleVars(angle, '--container-foto_angle', '--container-foto_angle-t', '--container-foto_angle-tr');
        },
        getFotoAngleVars(angle) {
            return this.getAngleVars(angle, '--foto-angle', '--foto-angle-t', '--foto-angle-tr');
        },
        getContainerAngleStyle(angle) {
            return this.styleToString(this.getContainerAngleVars(angle));
        },
        getNumberFromProperty(/** HTMLElement */ htmlElement, propertyName, defaultValue) {
            const angle = Number(htmlElement.style.getPropertyValue(propertyName));
            return Number.isFinite(angle) ? angle : defaultValue;
        },
        getContainerAngle(/** HTMLElement */ htmlElement) {
            return this.getNumberFromProperty(htmlElement, '--container-angle', 0);
        },
        getContainerFotoAngle(/** HTMLElement */ htmlElement) {
            return this.getNumberFromProperty(htmlElement, '--container-foto_angle', 0);
        },
        getFotoAngle(/** HTMLElement */ htmlElement) {
            return this.getNumberFromProperty(htmlElement, '--foto-angle', 0);
        },
        getZindexVars(zIndex) {
            return {
                '--container-z_index': zIndex,
            };
        },
        getContainerZindex(container) {
            return Number(container.style.getPropertyValue('--container-z_index')) || 0;
        },
        /**
         * Получить угол наклона контейнера
         *
         * @param $cont
         * @returns {float}
         */
        getContainerRealAngle($cont) {
            let angle = 0;
            for ($cont = $cont.closest('.page-container'); $cont.length; $cont = $cont.parents('.page-container')) {
                angle += this.getContainerAngle($cont[0]);
            }
            return Fotobook.book.normalizeAngle(angle);
        },
        /**
         * Получить классы для определенного типа контейнера
         *
         * @param element
         * @param classes
         * @returns {*|Array}
         */
        getContainerClasses(element, classes) {
            classes = classes || [];
            classes.push(Fotobook.book.containerClass, Fotobook.book.container_classes[element.type]);
            if (element.locked !== 0) {
                classes.push('locked');
            }
            if (Number(element.flipx) > 0) {
                classes.push('flipx');
            }
            if (Number(element.flipy) > 0) {
                classes.push('flipy');
            }
            if (element.page_id && !element.group_id) {
                classes.push('top-level');
            }

            return classes;
        },

        /** Установить значения для общих атрибутов контейнера */
        getContainerCommonData(/** Container */ element, dX) {
            const angle = Fotobook.angles.normalizeAngle(element.angle);
            const opacity = Number(element?.opacity ?? 100) / 100;
            const containerData = element.unit === Fotobook.CoordinateUnit.PERCENT ?
                {
                    height: `${element.height}%`,
                    width: `${element.width}%`,
                    left: `${element.x}%`,
                    top: `${element.y}%`,
                }
                :
                {
                    height: Fotobook.book.getSizeInEm(element.height * dX),
                    width: Fotobook.book.getSizeInEm(element.width * dX),
                    left: Fotobook.book.getSizeInEm(element.x * dX),
                    top: Fotobook.book.getSizeInEm(element.y * dX),
                };

            return {
                ...containerData,
                opacityStyle: `--container-opacity: ${opacity}`,
                angleStyle: this.getContainerAngleStyle(angle),
                id: element.id,
                zIndexStyle: this.styleToString(this.getZindexVars(element.z_index)),
                'data-width': element.width,
                'data-height': element.height,
            };
        },
        convertMandatoryCoordinateToPixels(/* PagePositionUnit */unit, /*number*/value, /*number*/parentSize, /*number*/k) {
            if (unit === Fotobook.PagePositionUnit.PERCENT) {
                return value * parentSize / 100;
            }
            if (unit === Fotobook.PagePositionUnit.MM) {
                return value * k;
            }
            if (unit === Fotobook.PagePositionUnit.CM) {
                return value * 10 * k;
            }

            throw new Error(`Unsupported unit:${String(unit)}`);
        },
        calculateOneMandatoryCoord(displayRegion, /* PagePosition */ position, /* bool */invertPosition, modelCoordinate, unit, parentSize, elementSize) {
            const coordinate = this.convertMandatoryCoordinateToPixels(unit, modelCoordinate, parentSize, displayRegion.k);
            if (position === Fotobook.PagePosition.CENTER) {
                return (parentSize - elementSize) / 2 + coordinate;
            }

            if (position === (invertPosition ? Fotobook.PagePosition.END : Fotobook.PagePosition.START)) {
                return coordinate;
            }

            return parentSize - coordinate - elementSize;
        },
        coordinate: {
            X: 0,
            Y: 1,
        },
        needsCoordinateInversion(page, coordinate) {
            const bookbindPosition = this.product.has_bookbind;
            if (bookbindPosition === Fotobook.BookbindPosition.NONE) {
                return false;
            }
            if (bookbindPosition === Fotobook.BookbindPosition.LEFT || bookbindPosition === Fotobook.BookbindPosition.TOP) {
                return false;
            }
            if (bookbindPosition === Fotobook.BookbindPosition.RIGHT || bookbindPosition === Fotobook.BookbindPosition.BOTTOM) {
                return true;
            }
            if (bookbindPosition === Fotobook.BookbindPosition.LEFT_RIGHT && coordinate === this.coordinate.Y) {
                return false;
            }
            if (bookbindPosition === Fotobook.BookbindPosition.TOP_BOTTOM && coordinate === this.coordinate.X) {
                return false;
            }
            return this.getPageOddness(page);
        },
        _mandatory_tpl: [
            '<svg class="pointer-events-none" style="position:absolute;top:{top};left:{left};width:{width};height:{height};z-index:', Fotobook.book.zindex.container_max, ';">',
                Fotobook.book.foreignObject ?
                    [
                        '<switch>',
                            '<foreignObject width="100%" height="100%">',
                                // z-index:-1 - исправление бага хрома, в нём содержимое почему-то перекрывает идущий следом rect
                                '<img src="{url}" alt="" style="position:absolute;top:0;left:0:width:100%;height:100%;display:block;z-index:-1;">',
                            '</foreignObject>',
                        '</switch>'
                    ].join('')
                    :
                    '<image xlink:href="{url}" width="100%" height="100%" />',
                '<rect x="{bar-x}" y="{bar-y}" width="{bar-width}" height="{bar-height}" fill-opacity=".1" />',
            '</svg>',
        ].join(''),
        drawMandatoryContainer(page, container) {
            const displayRegion = Fotobook.displayRegions.getRegion(page.type);
            const verticalSpread = this.isHorizontalBookbind();
            const element = container.element;
            const width = displayRegion.k * container.width;
            const k = width / element.width;
            const height = k * element.height;
            const centerShift = this.getCenterShift(page);
            const binding = this.getPageBinding(page);

            const left = this.calculateOneMandatoryCoord(
                displayRegion,
                container.x_position,
                this.needsCoordinateInversion(page, this.coordinate.X),
                container.x,
                container.x_unit,
                displayRegion.width + binding.left + binding.right,
                width
            );
            const top = this.calculateOneMandatoryCoord(
                displayRegion,
                container.y_position,
                this.needsCoordinateInversion(page, this.coordinate.Y),
                container.y,
                container.y_unit,
                displayRegion.height + binding.top + binding.bottom,
                height
            );

            const odd = this.getPageOddness(page);
            return Fotobook.book._mandatory_tpl.supplant({
                width: Fotobook.book.getSizeInEm(width),
                height: Fotobook.book.getSizeInEm(height),
                top: Fotobook.book.getSizeInEm(top - (verticalSpread ? 0 : centerShift) - (odd ? binding.top : 0)),
                left: Fotobook.book.getSizeInEm(left - (verticalSpread ? centerShift : 0) - (odd ? binding.left : 0)),
                url: Fotobook.createStorageUrl(element.preview_path),
                'bar-x': Fotobook.book.getSizeInEm(k * element.x1),
                'bar-y': Fotobook.book.getSizeInEm(k * element.y1),
                'bar-width': Fotobook.book.getSizeInEm(k * (element.x2 - element.x1)),
                'bar-height': Fotobook.book.getSizeInEm(k * (element.y2 - element.y1)),
            });
        },
        bindingDataToEm(data) {
            return {
                bindingTop: this.getClearSize(data.top),
                bindingRight: this.getClearSize(data.right),
                bindingBottom: this.getClearSize(data.bottom),
                bindingLeft: this.getClearSize(data.left),

                bindingTopEm: this.getSizeInEm(data.top),
                bindingRightEm: this.getSizeInEm(data.right),
                bindingBottomEm: this.getSizeInEm(data.bottom),
                bindingLeftEm: this.getSizeInEm(data.left),
            };
        },
        getPageBinding(page, flyleafPageNum) {
            const bindingArea = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            };
            const displayRegion = Fotobook.displayRegions.getRegion(page ? page.type : '', true);
            const bindingSize = displayRegion.bindingAreaWidth;
            const odd = this.getPageOddness(page, flyleafPageNum);

            switch (this.product.has_bookbind) {
                case Fotobook.BookbindPosition.LEFT_RIGHT:
                    if (odd) {
                        bindingArea.left = bindingSize;
                    } else {
                        bindingArea.right = bindingSize;
                    }
                    break;

                case Fotobook.BookbindPosition.LEFT:
                    bindingArea.left = bindingSize;
                    break;

                case Fotobook.BookbindPosition.RIGHT:
                    bindingArea.right = bindingSize;
                    break;

                case Fotobook.BookbindPosition.TOP:
                    bindingArea.top = bindingSize;
                    break;

                case Fotobook.BookbindPosition.BOTTOM:
                    bindingArea.bottom = bindingSize;
                    break;

                case Fotobook.BookbindPosition.TOP_BOTTOM:
                    if (odd) {
                        bindingArea.top = bindingSize;
                    } else {
                        bindingArea.bottom = bindingSize;
                    }
                    break;
            }
            return bindingArea;
        },
        getPageSpine(page) {
            const spine = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            };
            const spineThickness = this.getSpineThickness(page);

            switch (this.product.has_bookbind) {
                case Fotobook.BookbindPosition.LEFT_RIGHT:
                    spine.right = spineThickness;
                    break;

                case Fotobook.BookbindPosition.TOP_BOTTOM:
                    spine.bottom = spineThickness;
                    break;
            }
            return spine;
        },

            /** темплейт страницы */
        _page_tpl: [
            '<div class="book-page {page_classes}"',
            ' animation-duration="1"',
            ' data-id="{id}"',
            ' data-page-width="{page_w}"',
            ' data-page-height="{page_h}"',
            ' data-dx="{dx}"',
            ' data-center_shift="{centerShift}"',
            ' data-bleed="{bleed}"',
            ' data-bindingarea="{bindingAreaJson}"',
            ' data-spine="{spineJson}"',
            ' data-page_num="{page_num}"',
            ' data-page_type="{page_type}"',
            ' data-theme_page_id="{theme_page_id}"',
            ' style="width:{w}; height:{h}; margin:{marginTop} {marginRight} {marginBottom} {marginLeft}; --page-dx: {dx};">',
                '<div class="overflow-limiter overflow-limiter-bg">',
                   '<div class="bg bg-wrapper">',
                       '<div class="bg-wrapper-inner append-bg-content bg-drop-accept" style="width:{bgw};height:{bgh};">',
                           '{bg}',
                       '</div>',
                   '</div>',
                '</div>',
                '<div class="overflow-limiter overflow-limiter-container append-containers">',
                    '{containers}',
                '</div>',
            '</div>',
        ].join(''),

        getPageDx(page) {
            if (!page?.type) {
                return 1;
            }
            const displayRegion = Fotobook.displayRegions.getRegion(page.type);
            if (!displayRegion) {
                return 1;
            }
            if (!this.isHorizontalBookbind()) {
                return displayRegion.width / page.width;
            }
            return displayRegion.height / page.height;
        },

        mandatoryContainerShouldBeRenderedCover(/* MandatoryContainer */ mandatoryContainer, page) {
            if (!this.cover || !this.cover.foto_clipart) {
                return false;
            }
            if (mandatoryContainer.region_items === Fotobook.MandatoryContainerRegionItems.ALL) {
                return true;
            }
            const coverIsFront = this.product.covers_count === 1 || this.product.covers_count === 2 && page.page_num !== 0; // todo как-то стандартизировать переднюю/заднюю обложки
            if (coverIsFront) {
                return mandatoryContainer.region_items === Fotobook.MandatoryContainerRegionItems.FIRST;
            }
            return mandatoryContainer.region_items === Fotobook.MandatoryContainerRegionItems.LAST;
        },
        mandatoryContainerShouldBeRenderedPage(/* MandatoryContainer */ mandatoryContainer, page) {
            if (mandatoryContainer.region_items === Fotobook.MandatoryContainerRegionItems.ALL) {
                return true;
            }
            if (mandatoryContainer.region_items === Fotobook.MandatoryContainerRegionItems.FIRST) {
                return page.page_num === this.product.covers_count;
            }
            if (mandatoryContainer.region_items === Fotobook.MandatoryContainerRegionItems.LAST) {
                const pages = Fotobook.store.state.OnlineEditor.pages;
                const pagesCount = Object.values(pages).length;
                return page.page_num === pagesCount - 1;
            }
            return false;
        },
        mandatoryContainerShouldBeRendered(mandatoryContainer, page) {
            if (!mandatoryContainer.active || !mandatoryContainer.element.active) {
                return false;
            }
            if (page.type !== mandatoryContainer.region) {
                return false;
            }
            if (!this.product.is_custom_substrate && page.type === Fotobook.PageType.COVER) {
                return this.mandatoryContainerShouldBeRenderedCover(mandatoryContainer, page);
            }

            return this.mandatoryContainerShouldBeRenderedPage(mandatoryContainer, page);
        },
        getMandatoryContainers() {
            const product = Fotobook.store.state.productsConfig.products[this.product.id];
            return product && product.mandatoryContainers || [];
        },
        drawMandatoryContainers(page) {
            return this.getMandatoryContainers().reduce((result, mandatoryContainer) => {
                if (this.mandatoryContainerShouldBeRendered(mandatoryContainer, page)) {
                    result.push(this.drawMandatoryContainer(page, mandatoryContainer));
                }
                return result;
            }, []);
        },
        /**
         * Формирование страницы для нижней панели
         *
         * @param {object} data - информация о странице
         * @return {string} - html код стрвницы
         */
        drawPage(data) {
            var page = data.page,
                odd = this.getPageOddness(page, data.flyleaf_page_num),
                page_num = page ? page.page_num : data.flyleaf_page_num,
                page_type = page && page.type || Fotobook.PageType.PAGE,
                displayRegion = Fotobook.displayRegions.getRegion(page_type),
                dX = this.getPageDx(page),
                containers = [],
                binding = this.getPageBinding(page, data.flyleaf_page_num),
                spine = this.getPageSpine(page),
    // Так как размеры страницы не всегда идеально совпадают с соотношением сторон, необходимо скорректировать
    // смещение на эту разницу, чтобы элементы центровались по высоте
                centerShift = this.getSizeInEm(this.getCenterShift(page)),
                page_classes = [data.lr, "page_num_" + page_num, "page_" + (odd ? "odd" : "even")],
                pageWidth = this.getSizeInEm(displayRegion.width),
                pageHeight = this.getSizeInEm(displayRegion.height),
                wrap = $.extend({
                    centerShift,
                    width: pageWidth,
                    height: pageHeight,
                }, this.bindingDataToEm(binding));

            if (page) {
                // todo - исправить классы!
                page_classes.push(`page_${page.id}`, page.type === Fotobook.PageType.COVER ? 'cover' : 'page');
                for (let id in page.containers) {
                    if (Object.prototype.hasOwnProperty.call(page.containers, id)) {
                        wrap.content = this.drawContainer(page.containers[id], dX, page_type);
                        containers.push(this.wrapContainer(wrap));
                    }
                }
                wrap.content = this.drawMandatoryContainers(page).join('');
                containers.push(this.wrapContainer(wrap));
            } else {
                page_classes.push('flyleaf-page');
                wrap.content = this.drawPageInfo();
                containers.push(this.wrapContainer(wrap));
            }

            return this._page_tpl.supplant($.extend({
                id: page ? page.id : '',
                page_classes: page_classes.join(' '),
                bg: this.drawPageBackground(page),
                page_w: page ? page.width : 0,
                page_h: page ? page.height : 0,
                w: pageWidth,
                h: pageHeight,
                dx: dX,
                page_num: page_num,
                page_type: page_type,
                centerShift: centerShift,
                containers: containers.join(''),
                marginTop: this.getSizeInEm(binding.top + spine.top),
                marginRight: this.getSizeInEm(binding.right + spine.right),
                marginBottom: this.getSizeInEm(binding.bottom + spine.bottom),
                marginLeft: this.getSizeInEm(binding.left + spine.left),
                bgw: this.getSizeInEm(displayRegion.width + spine.left + spine.right + binding.left + binding.right),
                bgh: this.getSizeInEm(displayRegion.height + spine.top + spine.bottom + binding.top + binding.bottom),
                // Refactor
                bleed: displayRegion.bleed_box,
                bindingAreaJson: JSON.stringify(binding).escapeAttr(),
                spineJson: JSON.stringify(spine).escapeAttr(),
                theme_page_id: page ? page.theme_page_id : null,
            }, {}));
        },
        /**
         * Получить ширину корешка
         */
        getSpineThickness(page) {
            let pageNum = 0,
                type;

            if (this.product.covers_count !== 2 || this.bookbind.spine === Fotobook.SpineType.NONE || this.cover.spine === Fotobook.SpineType.NONE) {
                return 0;
            }

            // передан форзац
            if (page === undefined) {
                type = Fotobook.PageType.COVER;
            } else if (page === null) {
                type = Fotobook.PageType.PAGE;
            } else if (typeof page === 'string') {
                type = page;
            } else if (typeof page === 'object') {
                // передана страница. корешок пристыковывается к задней обложке (индекс 0)
                type = page.type;
                pageNum = page.page_num;
            }

            const displayRegion = Fotobook.displayRegions.getRegion(type);
            if (!displayRegion || pageNum !== 0) {
                return 0;
            }
            return displayRegion.spineWidth;
        },
        getNodesTextContent(list) {
            const r = [];
            for (let i = list.length - 1; i > -1; i--) {
                r.unshift(list[i].textContent);
            }
            return r.join('');
        },
        textContentEmpty(content) {
            if (content instanceof Array || content instanceof NodeList || content instanceof HTMLCollection) {
                content = Fotobook.book.getNodesTextContent(content);
            }
            return content.match(/[^\n ]/g) === null;
        },
        forceFontSizeToEm(changed) {
            this.each(function () {
                let fs = this.style.fontSize;
                if (fs) {
                    fs = fs.match(/([\d\.-]+)([a-z]+)$/);
                }
                if (fs && fs[2] !== 'em') {
                    const $this = $(this);
                    const fs_current = parseFloat($this.css('font-size'));
                    this.style.fontSize = '';
                    const fs_base = parseFloat($this.css('font-size'));
                    this.style.fontSize = fs_current / fs_base + 'em';
                    changed = true;
                }
            });
            return changed;
        },

        setupCalendarContainer() {
            Fotobook.book.recalcContainer.call(this);
        },
        setupTextContainer() {
            if (!this.hasClass("spine") && this.hasClass("top-level")) {
                this.find(".container-box-shadow").append(Fotobook.book._containerBorderDragHandle);
            }
        },
        recalcCalendarDateMarkRatio() {
            const container = this[0];
            const dateMarkFoto = container.querySelector('.date-mark-wrapper.foto');
            if (!dateMarkFoto) {
                return;
            }
            const style = window.getComputedStyle(dateMarkFoto);
            const width = parseFloat(style.width);
            const height = parseFloat(style.height);
            if (!width || !height) {
                return;
            }
            const ratio = width / height;
            if (!ratio || isNaN(ratio)) {
                return;
            }
            container.style.setProperty('--calendar-date-mark-ratio', ratio);
        },
        recalcTextShadow() {
            var angle = -Fotobook.book.getContainerRealAngle(this).toRad(),
                sinus = Math.sin(angle),
                cosinus = Math.cos(angle),
                dx = parseFloat(this.attr("data-shadow-dx")),
                dy = parseFloat(this.attr("data-shadow-dy")),
                new_dx = dx * cosinus - dy * sinus,
                new_dy = dy * cosinus + dx * sinus,
                isShadow = !new_dx && !new_dy && !this.attr("data-shadow-blur");

            this.find(".text-content,.redactor-general").css({
                "text-shadow": isShadow ? "" : [new_dx, "em ", new_dy, "em ", this.attr("data-shadow-blur"), "em ", this.attr("data-shadow-color")].join(""),
            });
        },
        dropShadowTextAttrs(shadow) {
            const attrs = {
                'shadow-dx': shadow ? shadow.dx : '',
                'shadow-dy': shadow ? shadow.dy : '',
                'shadow-blur': shadow ? shadow.blur : '',
                'shadow-color': '',
            };
            if (shadow) {
                const color = new WebColor(shadow.color);
                color.a *= shadow.opacity;
                attrs["shadow-color"] = color.get_smart();
            }
            return attrs;
        },

        /** темплейт текстового контейнера */
        _text_element_tmpl:
            `<div
                class="{classes} cont_{id}"
                data-container-type="${Fotobook.ContainerType.CAPTION}"
                data-id="{id}"
                data-width="{data-width}"
                data-height="{data-height}"
                data-qtip-selector="photobook-tooltipText-edit-caption"
                data-shadow-dx="{shadow-dx}"
                data-shadow-dy="{shadow-dy}"
                data-shadow-blur="{shadow-blur}"
                data-shadow-color="{shadow-color}"
                data-text-content-ratio="{textContentRatio}"
                {languageKey}
                style="height:{height}; width:{width}; top:{top}; left:{left}; {angleStyle}; {opacityStyle}; {zIndexStyle};"
            >
                <div class="container-box-shadow">',
                    <div class="set-opacity">{caption}</div>
                </div>
            </div>`,

        /** отрисовка текстового контейнера */
        drawTextElement(element, dX) {
            const caption = this.captions.drawCaption(element.caption, dX, false);
            const classes = ['ajax-tooltip'];
            let languageKey = '';

            if (Fotobook.book.isEmptyCaption($(caption).find('.text-content'))) {
                classes.push('empty-caption');
            }
            if (element.drop_shadow) {
                classes.push('text-shadow');
            }
            if (element.caption.language_key) {
                languageKey = 'data-language-key="' + element.caption.language_key.escapeAttr() + '" ';
                classes.push('custom-empty-placeholder');
            }

            return Fotobook.book._text_element_tmpl.supplant({
                caption,
                languageKey,
                classes: Fotobook.book.getContainerClasses(element, classes).join(' '),
                ...Fotobook.book.getContainerCommonData(element, dX),
                ...Fotobook.book.dropShadowTextAttrs(element.drop_shadow),
                textContentRatio: element.text_content_ratio || '',
            });
        },

        appendSpine(spine) {
            var self = this,
                $spineOuter = $(".spine-outer"),
                editing = false;
            if (spine && spine.caption && spine.type === Fotobook.ContainerType.SPINE) {
                spine = $(Fotobook.book.drawSpine(spine));
            }
            if ($spineOuter.length) {
                editing = $spineOuter.find(".page-container.editing").length;
                $(".spine-outer").remove();
            }
            $(".book-page.cover.left").closest(".pages-wrapper").prepend(spine);
            if (editing) {
                setTimeout(() => $(self.book).find(".spine-outer .page-container").containerEditor());
            }
        },
        _spine_tmpl: [
            '<span class="spine-outer booklet-remove">',
                '<div ',
                    'class="{classes}" ',
                    'data-container-type="', Fotobook.ContainerType.SPINE, '" ',
                    'data-id="{id}" ',
                    'data-dx="{dx}" ',
                    'data-qtip-selector="photobook-tooltipText-edit-caption" ',
                    'style="width:{h};height:{w};line-height:{w};background-color:{background}; --page-dx: {dx};"',
                '>',
                    '<div class="container-box-shadow">',
                        '<div class="spine-caption-wrapper" style="position:absolute; top:{verticalSpineSafe}; bottom: {verticalSpineSafe}; left: {horizontalSpineSafe}; right: {horizontalSpineSafe};">',
                            '{caption}',
                        '</div>',
                    '</div>',
                '</div>',
            '</span>',
        ].join(''),
        drawSpine(spine) {
            const displayRegion = Fotobook.displayRegions.getRegion(Fotobook.PageType.COVER);

            if (!displayRegion) {
                return '';
            }

            var dx = parseFloat($(".pages-wrapper").find(".book-page.cover").attr("data-dx")),
                id = spine.id,
                safe = this.getSizeInEm(displayRegion.art_box.safe_area),
                verticalSpread = this.isHorizontalBookbind(),
                spineThickness = Fotobook.book.getSpineThickness(Fotobook.PageType.COVER),
                h = verticalSpread ? spineThickness : displayRegion.height,
                w = verticalSpread ? displayRegion.width : spineThickness,
                caption = this.captions.drawCaption(spine.caption, dx, true),
                classes = ["spine", "text-container", Fotobook.book.containerClass, `sp_${id}`, `cont_${id}`, "ajax-tooltip"];

            if (!$.trim($(caption).find(".text-content").text()).length) {
                classes.push("empty-caption");
            }
            return Fotobook.book._spine_tmpl.supplant({
                "id": id,
                "classes": classes.join(" "),
                "w": Fotobook.book.getSizeInEm(w),
                "h": Fotobook.book.getSizeInEm(h),
                "l": Fotobook.book.getSizeInEm(-h / 2),
                "t": Fotobook.book.getSizeInEm(-w / 2),
                "dx": dx,
                "background": spine.caption.bgcolor,
                "caption": caption,
                verticalSpineSafe: verticalSpread ? safe : 0,
                horizontalSpineSafe: verticalSpread ? 0 : safe,
            });
        },
        artefactLowQuality: ['<img src="/images/attention.png" alt="Low quality" class="low-quality-mark ajax-tooltip" data-qtip-selector="photobook-tooltipText-low-quality-artefact">'].join(""),
        setupArtefactContainer() {
            this.append(Fotobook.book.artefactLowQuality);
            Fotobook.book.recalcContainer.call(this);
        },
        _artefact_tpl: [
            '<div class="{classes} cont_{id}"',
                'data-container-type="', Fotobook.ContainerType.ARTEFACT, '" ',
                'data-qtip-selector="photobook-tooltipText-edit-caption" ',
                'data-height="{data-height}" ',
                'data-width="{data-width}" ',
                'data-id="{id}" ',
                'data-artefact_id="{artefact_id}" ',
                'style="left:{left}; top:{top}; width:{width}; height:{height}; {angleStyle}; {opacityStyle}; {zIndexStyle};"',
            '>',
                '<div class="container-box-shadow">',
                    '<svg class="root-svg root-svg-artefact set-opacity" ', Fotobook.xmlns, ' version="1.1" x="0" y="0" width="100%" height="100%">',
                        '<defs class="defs">',
                            '{drop_shadow}',
                        '</defs>',
                        '<g class="apply-drop-shadow {drop_shadow-class}" {drop_shadow-attr}>',
                            // в ФФ SVG-изображения отображаются без сглаживания, а в вебкитах глюки при ресайзе артефактов с flipx/flipy - используем foreignObject
                            (Fotobook.book.foreignObject ?
                                [
                                    '<switch>',
                                        '<foreignObject class="apply-flip" x="{flip_x}" y="{flip_y}" width="100%" height="100%" transform="{flip_transform}">',
                                            '<img src="{path}?version={v}" alt="Artefact" class="artefact-image" data-width="{artefact_width}" data-height="{artefact_height}">',
                                        '</foreignObject>',
                                    '</switch>'
                                ].join("")
                                :
                                '<image class="apply-flip" xlink:href="{path}?version={v}" x="{flip_x}" y="{flip_y}" width="100%" height="100%" transform="{flip_transform}" />'
                            ),
                        '</g>',
                    '</svg>',
                '</div>',
            '</div>',
        ].join(''),
        drawArtefactElement(artefact, dX) {
            var path = Fotobook.createStorageUrl(artefact.artefact.preview_path),
                classes = [],
                // В ИЕ трансформации не работают, если описаны в CSS - только атрибутом. Также не работает translate, заданный в процентах. Реализуем флипы таким образом
                flip = this.getFlipAttrs(artefact.flipx, artefact.flipy),
                drop_shadow = this.drawDropShadow(artefact.drop_shadow),
                drop_shadow_attr = "",
                drop_shadow_class = "";

            if (!artefact.locked && Fotobook.book.custom) {
                classes.push("ajax-tooltip");
            }
            if (drop_shadow) {
                const filter_id = Fotobook.book.getUniqueId();
                drop_shadow_attr = 'filter="url(#' + filter_id + ')"';
                drop_shadow_class = this.getFilterApplyClass(filter_id);
                drop_shadow = drop_shadow.supplant({
                    "drop_shadow-svg-id": filter_id,
                });
            }

            return this._artefact_tpl.supplant({
                "classes": Fotobook.book.getContainerClasses(artefact, classes).join(" "),
                "artefact_id": artefact.artefact.id,
                "path": path,
                "v": artefact.artefact.version || 0,
                "drop_shadow": drop_shadow,
                "drop_shadow-attr": drop_shadow_attr,
                "drop_shadow-class": drop_shadow_class,
                "apply_flip_class": Fotobook.book.foreignObject ? "apply-flip-html" : "",
                flip_x: flip.x,
                flip_y: flip.y,
                flip_transform: flip.transform,
                artefact_height: artefact.artefact.height,
                artefact_width: artefact.artefact.width,
                ...this.getContainerCommonData(artefact, dX),
            });
        },
        setupGroupContainer() {
            if (this.hasClass("top-level")) {
                this.find(".container-box-shadow").first().append(Fotobook.book._containerBorderDragHandle);
            }
        },
        drawGroupElement(element, dX, region, parentWidth, parentHeight) {
            const template =
                `<div class="cont_{id} {classes}"
                    data-container-type="${Fotobook.ContainerType.GROUP}"
                    data-id="{id}"
                    data-width="{data-width}"
                    data-height="{data-height}"
                    style="height:{height};width:{width};top:{top};left:{left};{zIndexStyle};{angleStyle}; {opacityStyle};"
                >
                    <div class="container-box-shadow">
                        <div class="group-content">
                            {content}
                        </div>
                    </div>
                </div>`
            ;

            return template.supplant({
                classes: Fotobook.book.getContainerClasses(element).join(' '),
                content: Fotobook.book.drawContainers(
                    element.containers,
                    dX,
                    region,
                    (element.unit === Fotobook.CoordinateUnit.PERCENT ? element.width * parentWidth / 100 : element.width),
                    (element.unit === Fotobook.CoordinateUnit.PERCENT ? element.height * parentHeight / 100 : element.height)
                ),
                ...Fotobook.book.getContainerCommonData(element, dX),
            });
        },
        fotoContainerControls_before: [
            '<div class="controls-button oe-sprite-image-ba cropping-handle ajax-tooltip" animate="fadeIn" animation-repeat data-qtip-selector="photobook-tooltipText-icon-cropping-move"></div>',
            '<div class="controls-button-wrapper">',
                Fotobook.config.data[Fotobook.Settings.SHOW_PHOTO_EDITOR_BUTTON] ? '<div class="controls-button oe-sprite-image-ba edit-foto ajax-tooltip" animate="zoomIn" animation-repeat data-qtip-selector="photobook-tooltipText-icon-edit-photo"></div>' : '',
                '<div class="controls-button oe-sprite-image-ba delete-foto-instant ajax-tooltip" animate="zoomIn" animation-repeat  data-qtip-selector="photobook-tooltipText-icon-delFoto-instant"></div>',
                '<div class="controls-button oe-sprite-image-ba upload-foto ajax-tooltip" animate="zoomIn" animation-repeat data-qtip-selector="photobook-tooltipText-icon-upload-foto"></div>',
            '</div>',
        ].join(''),
        fotoContainerControls_after: [
            '<div class="drop-placeholder-text text-fit-to-parent" style="display:none;">', t("photobook-js-dropPhotoPlaceholder"), '</div>',
            '<div class="swap-photos-text text-fit-to-parent">', t("photobook-js-swapPhotosPlaceholder"), '</div>',
            '<div class="controls container-box-shadow">',
                '<img src="/images/attention.png" alt="Low quality" class="low-quality-mark ajax-tooltip" data-qtip-selector="photobook-tooltipText-low-quality-{qtip_edit_mode}">',
                '<img src="/images/error.png" alt="Original missing" class="original-missing-mark ajax-tooltip" data-qtip-selector="photobook-tooltipText-imageCorrupted">',
            '</div>',
        ].join(''),
        fotoCropping_append: [
            '<rect class="preview-background" x="0" y="0" width="100%" height="100%" fill="white" />',
            '<svg class="set-image-size" x="50%" y="50%" width="0" height="0" overflow="visible">',
                '<image class="foto-image-preview" x="0" y="0" width="100%" height="100%" xlink:href="" preserveAspectRatio="xMidYMid slice" data-id="" />',
            '</svg>',
        ].join(''),
        fotoCropping_image: [
            '<image x="0" y="0" width="100%" height="100%" xlink:href="{image-href}" class="foto-image-cropping" opacity=".8" mask="url(#{outer-mask-id})" />',
            '<rect x="0" y="0" width="100%" height="100%" class="foto-image-cropping" fill="white" opacity=".3"  mask="url(#{outer-mask-id})" />',
        ].join(''),
        setupFotoContainer() {
            const $foto_image = this.find('.foto-image');
            const ids = {
                'inner-mask-id': Fotobook.book.getUniqueId(),
                'outer-mask-id': Fotobook.book.getUniqueId(),
            };

            this.find(".root-svg-foto").before(Fotobook.book.fotoContainerControls_before);
            this.find(".root-svg-foto").after(Fotobook.book.fotoContainerControls_after.supplant({
                qtip_edit_mode: Fotobook.store.state.OnlineEditor.editModeCode,
            }));

            this.find(".cropping")[0].append(Fotobook.book.fotoCropping_append.supplant(ids));

            this.find("image.foto-image-cropping").attr("xlink:href", $foto_image.attr("xlink:href"));
            Fotobook.fotoContainerDroppable.setupFotoContainerDroppable(this);
            Fotobook.book.recalcContainer.call(this);
        },
        getFotoContainerUserFilter(element) {
            if (
                element.brightness === Fotobook.CompositeFilter.DEFAULT_EFFECT_VALUE &&
                element.contrast === Fotobook.CompositeFilter.DEFAULT_EFFECT_VALUE &&
                element.saturation == Fotobook.CompositeFilter.DEFAULT_EFFECT_VALUE
            ) {
                return '';
            }
            const filterId = Fotobook.CompositeFilter.getEffectSelectorName(element.id);
            return `filter="url(#${filterId})"`;
        },
        _foto_container_tpl: `<div class="cont_{id} subtype-{subtype} {classes}"
            {data_qtip}
            data-container-type="${Fotobook.ContainerType.FOTO}"
            data-id="{id}"
            data-subtype="{subtype}"
            data-bleed="{bleed}"
            data-width="{data-width}"
            data-height="{data-height}"
            data-filters='{data-filters}'
            style="height:{height};width:{width};top:{top};left:{left};{zIndexStyle};{fotoAngleStyle};{containerFotoAngleStyle};{opacityStyle};{angleStyle};"
        >
            <svg class="root-svg root-svg-foto set-opacity" ${Fotobook.xmlns} version="1.1" x="0" y="0" width="100%" height="100%" overflow="visible">
                <defs class="defs">
                    {drop_shadow}
                    {mask}
                </defs>
                <g class="apply-drop-shadow append-frame {drop_shadow-class}" {drop_shadow-attr}>
                    <svg class="overflow-mask" x="0" y="0" width="100%" height="100%">
                        <svg class="set-image-size" x="50%" y="50%" width="{image_width}" height="{image_height}">
                            <image x="-{crop_cx}%" y="-{crop_cy}%" width="100%" height="100%" xlink:href="{img_path}" class="{foto_classes}" data-id="{foto_id}"
                                    data-original_exists="{originalExists}"
                                    data-width="{foto_width}" data-height="{foto_height}"
                                    data-crop_cx="{crop_cx}" data-crop_cy="{crop_cy}"
                                    data-crop_width="{crop_width}" data-crop_height="{crop_height}"
                                    style="{fotoAngleCss}"
                            />
                        </svg>
                    </svg>
                    <g class="apply-mask" {mask-attr} {predefinedFilterName}>
                        <svg class="cropping" x="0" y="0" width="100%" height="100%">
                            <svg class="set-image-size" x="50%" y="50%" width="{image_width}" height="{image_height}">
                                <image x="-{crop_cx}%" y="-{crop_cy}%" width="100%" height="100%" xlink:href="{img_path}" class="{foto_classes}" data-id="{foto_id}"
                                        data-original_exists="{originalExists}"
                                        data-width="{foto_width}" data-height="{foto_height}"
                                        data-crop_cx="{crop_cx}" data-crop_cy="{crop_cy}"
                                        data-crop_width="{crop_width}" data-crop_height="{crop_height}"
                                        style="{fotoAngleCss}"
                                        {userFilterName}
                                />
                            </svg>
                        </svg>
                        <image x="0" y="0" width="100%" height="100%" xlink:href="{placeholder_path}" preserveAspectRatio="xMidYMid slice" class="foto-placeholder booklet-remove" data-id="{ph_id}" />
                        ${Fotobook.noOriginalTmplSvg('no-original-block booklet-remove')},
                    </g>
                    {frame}
                </g>
            </svg>
            ${Fotobook.ajaxLoaderMin}
        </div>`,
        drawFotoElement(/** FotoContainer */ element, dX, region, parentWidth, parentHeight) {
            /** @var {Foto} foto */
            const foto = element.foto;
            let data_qtip = '';
            const displayRegion = Fotobook.displayRegions.getRegion(region);
            const bleed = displayRegion.k * (element.bleed || 0);
            let img_path = this.getFotoPath(foto);
            let placeholder_path = '';
            const fotoID = foto?.id ?? '';
            const classes = [];
            const foto_classes = ['foto-image'];
            const image_size = {
                image_width: '100%',
                image_height: '100%',
                style: '',
            };
            const mask = element.mask_id ? this.drawMask(element) : (element.rx > 0 ? this.drawMask({
                mask: {
                    figure: 'rect',
                    height: 1000,
                    width: 1000,
                    id: -1,
                    rx: element.rx,
                    type: Fotobook.book.TYPE_VECTOR,
                },
            }) : '');
            let mask_attr = mask ? 'mask="url(#{mask-svg-id})"' : '';
            let drop_shadow = Fotobook.book.drawDropShadow(element.drop_shadow);
            let drop_shadow_attr = '';
            let drop_shadow_class = '';

            if (fotoID) {
                foto_classes.push(`foto_${fotoID}`);
                if (!foto.originalExists) {
                    classes.push('no-original ajax-tooltip');
                    data_qtip = 'data-qtip-selector="photobook-tooltipText-imageCorrupted"';
                    if (Fotobook.import.isUploadingNow(Fotobook.ClipartType.FOTO, foto.id)) {
                        classes.push('uploading');
                    }
                }
                const fullFotoAngle = element.foto_angle + foto.angle;
                const cropping = Fotobook.book.getFotoCroppingSizes({
                    angle: fullFotoAngle,
                    foto_width: foto.width,
                    foto_height: foto.height,
                    crop_width: element.crop_width || 100,
                    crop_height: element.crop_height || 100,
                    crop_cx: element.crop_cx ?? 50,
                    crop_cy: element.crop_cy ?? 50,
                    cont_width: (element.unit === Fotobook.CoordinateUnit.PERCENT ? element.width * (parentWidth || 0) / 100 : element.width) + 2 * bleed / dX,
                    cont_height: (element.unit === Fotobook.CoordinateUnit.PERCENT ? element.height * (parentHeight || 0) / 100 : element.height) + 2 * bleed / dX,
                });
                image_size.image_width = Fotobook.book.getSizeInEm(dX * cropping.image_width);
                image_size.image_height = Fotobook.book.getSizeInEm(dX * cropping.image_height);
            } else {
                classes.push('empty');
            }
            if (drop_shadow) {
                const filter_id = Fotobook.book.getUniqueId();
                drop_shadow_attr = `filter="url(#${filter_id})"`;
                drop_shadow_class = this.getFilterApplyClass(filter_id);
                drop_shadow = drop_shadow.supplant({
                    'drop_shadow-svg-id': filter_id,
                });
            }

            if (element.foto_placeholder && element.foto_placeholder.preview_path) {
                placeholder_path = Fotobook.createStorageUrl([element.foto_placeholder.preview_path, '?v=', element.foto_placeholder.version || 1].join(''));
            } else {
                // в теме нет заглушки для пустых фотоконтейнеров, подставляем свою
                placeholder_path = Fotobook.config.data[Fotobook.Settings.STATIC_DEFAULT_FOTO_PLACEHOLDER];
            }

            const data_filters = this.getEffectsContainersData(element);
            const predefinedFilterName = element.filter ? `filter="url(#${element.filter})"` : '';
            let r = Fotobook.book._foto_container_tpl.supplant({
                containerFotoAngleStyle: this.styleToString(this.getContainerFotoAngleVars(element.foto_angle)),
                fotoAngleCss: this.styleToString(this.getFotoAngleVars(foto?.angle ?? 0)),
                bleed: bleed,
                classes: Fotobook.book.getContainerClasses(element, classes).join(' '),
                crop_cx: element.crop_cx || 50,
                crop_cy: element.crop_cy || 50,
                crop_width: element.crop_width || 100,
                crop_height: element.crop_height || 100,
                'data-filters': JSON.stringify(data_filters),
                drop_shadow,
                'drop_shadow-attr': drop_shadow_attr,
                'drop_shadow-class': drop_shadow_class,
                data_qtip,
                foto_classes: foto_classes.join(' '),
                foto_id: fotoID,
                foto_width: foto?.width ?? 0,
                foto_height: foto?.height ?? 0,
                originalExists: foto?.originalExists ? 1 : 0,
                frame: Fotobook.book.drawFrame(element, dX),
                img_path,
                mask,
                'mask-attr': mask_attr,
                'placeholder_path': placeholder_path,
                predefinedFilterName,
                'ph_id': element.foto_placeholder ? element.foto_placeholder.id : 0,
                subtype: element.subtype,
                userFilterName: self.getFotoContainerUserFilter(element),
                ...image_size,
                ...Fotobook.book.getContainerCommonData(element, dX),
            });

            if (mask) {
                r = r.supplant({
                    'mask-svg-id': mask ? Fotobook.book.getUniqueId() : '',
                });
            }
            return r;
        },
        setupBookContainer(event) {
            const $e = $(this);
            $e.addClass('editor-container');
            switch (Number($e.attr('data-container-type'))) {
                case Fotobook.ContainerType.FOTO: {
                    Fotobook.book.setupFotoContainer.call($e);
                    Fotobook.draggable.buildAlignLines($e);
                    break;
                }

                case Fotobook.ContainerType.ARTEFACT: {
                    Fotobook.book.setupArtefactContainer.call($e);
                    Fotobook.draggable.buildAlignLines($e);
                    break;
                }

                case Fotobook.ContainerType.CAPTION: {
                    Fotobook.book.setupTextContainer.call($e);
                    Fotobook.draggable.buildAlignLines($e);
                    break;
                }

                case Fotobook.ContainerType.SPINE:
                    Fotobook.book.setupTextContainer.call($e);
                    break;

                case Fotobook.ContainerType.GROUP: {
                    Fotobook.book.setupGroupContainer.call($e);
                    Fotobook.draggable.rebuildAlignLines($e);
                    break;
                }

                case Fotobook.ContainerType.CALENDAR:
                    Fotobook.book.setupCalendarContainer.call($e);
                    Fotobook.draggable.buildAlignLines($e);
                    break;
            }
        },
        getContainerWrapData($e) {
            const $page = $e.closest('.book-page');
            const style = $page[0].style;
            return $.extend({
                width: style.width,
                height: style.height,
                centerShift: $page.attr('data-center_shift'),
            }, this.bindingDataToEm(JSON.parse($page.attr('data-bindingarea'))));
        },

        /**
         * Обертка для контейнера
         */
        _wrap_tpl: [
            '<div class="cont-wrapper resizable-squares" style="margin:-{bindingTopEm} -{bindingRightEm} -{bindingBottomEm} -{bindingLeftEm}">',
                '<div class="cont-wrapper-inner append-content" style="{sizeAttr};{centerShiftAttr};">',
                    '{content}',
                '</div>',
            '</div>',
        ].join(''),

        /**
         * Обернуть контейнер и добавить позиционирование
         *
         * @param data
         * @returns {*}
         */
        wrapContainer(data) {
            const verticalSpread = this.isHorizontalBookbind();

            if (verticalSpread) {
                data.centerShiftAttr = `left:${data.centerShift}`;
                data.sizeAttr = `height:${data.height}`;
            } else {
                data.centerShiftAttr = `top:${data.centerShift}`;
                data.sizeAttr = `width:${data.width}`;
            }
            return this._wrap_tpl.supplant(data);
        },

        /** Отрисовать контейнер согласно типу (прокси функция) */
        drawContainer(element, dX, region, parent_width, parent_height) {
            let cont = '';
            switch (parseInt(element.type, 10)) {
                case Fotobook.ContainerType.FOTO:
                    cont = this.drawFotoElement(element, dX, region, parent_width, parent_height);
                    this.applyEffects($(cont), element);
                    break;
                case Fotobook.ContainerType.CAPTION:
                    cont = this.drawTextElement(element, dX);
                    break;
                case Fotobook.ContainerType.CALENDAR:
                    cont = Fotobook.containers.calendar.draw(element, dX);
                    break;
                case Fotobook.ContainerType.ARTEFACT:
                    cont = this.drawArtefactElement(element, dX);
                    break;
                case Fotobook.ContainerType.GROUP:
                    cont = this.drawGroupElement(element, dX, region, parent_width, parent_height);
                    break;
                default:
                    console.error("Unknown element type " + element.id + " " + element.type + "!");
            }

            return cont;
        },
        drawContainers(elements, dX, region, parent_width, parent_height) {
            const containers = [];
            for (let id in elements) {
                if (Object.prototype.hasOwnProperty.call(elements, id)) {
                    containers.push(Fotobook.book.drawContainer(elements[id], dX, region, parent_width, parent_height));
                }
            }
            return containers.join('');
        },
        drawPageInfo() {
            return  '<div class="pageInfo"><div class="pageInfo-inner-wrapper"><div class="pageInfo-title"><div class="info-mark">i</div>' + t('photobook-js-pageInfo-title') + '</div></div></div>';
        },

    // Filters stuff
        recalcFilter_DropShadow() {
            const $this = $(this);
            const $cont = $this.closest(".page-container");
            const bw = $cont.width();
            const bh = $cont.height();
            const angle = -Fotobook.book.getContainerRealAngle($cont).toRad();
            const sinus = Math.sin(angle);
            const cosinus = Math.cos(angle);
            const blur = $this.find("feGaussianBlur")[0];
            const offset = $this.find("feOffset")[0];
            const dx = offset.getAttribute("data-dx") * bw;
            const dy = offset.getAttribute("data-dy") * bh;

            blur.setAttribute("stdDeviation", blur.getAttribute("data-blur") * (bw + bh));
            offset.setAttribute("dx", dx * cosinus - dy * sinus);
            offset.setAttribute("dy", dy * cosinus + dx * sinus);
        },

        getFilterBaseFnName() {
            switch (Number($(this).attr('data-filter-type'))) {
                case Fotobook.FilterType.DROP_SHADOW:
                    return 'DropShadow';
            }
            return null;
        },
        recalcFilter() {
            const baseFnName = Fotobook.book.getFilterBaseFnName.call(this);
            if (!baseFnName) {
                return;
            }
            const fun = Fotobook.book[`recalcFilter_${baseFnName}`];
            if (fun && fun.constructor === Function) {
                fun.call(this);
            }
        },
        _drop_shadow_tpl: [
            '<filter id="{drop_shadow-svg-id}" class="filter-drop-shadow filter_{id} filter" data-id="{id}" data-filter-type="{type}" {size}>',
                '<feFlood class="apply-flood-color apply-flood-opacity" flood-opacity="{opacity}" flood-color="{color}" data-flood-color="{color}" data-flood-opacity="{opacity}" />',
                '<feComposite in2="SourceGraphic" operator="in" />',
                '<feGaussianBlur class="apply-shadow-blur" stdDeviation="0" data-blur="{blur}" />',
                '<feOffset class="apply-shadow-position" dx="0" dy="0" data-dx="{dx}" data-dy="{dy}" />',
                '<feComposite in="SourceGraphic" operator="over" />',
            '</filter>',
        ].join(''),
        getDropShadowOpacity(opacity) {
            return (Math.max(0, Math.min(1, Math.abs(opacity)))).toFixed(2);
        },
        drawDropShadow(filter) {
            if (!filter) {
                return '';
            }
    // !!!баг: хром при явно указанных размерах фильтра начинает уменьшать содержимое, к которому фильтр применён.
    // Из-за теней у артефактов, использовать хак с уменьшением размера фильтра мы не можем
            var full_size = 300,
                shift = (full_size - 100) / 2,
                size = 'x="{shift}%" y="{shift}%" width="{full_size}%" height="{full_size}%"'.supplant({
                    full_size,
                    shift: -shift,
                });

            return this._drop_shadow_tpl.supplant({
                size,
                id: filter.id,
                type: filter.type,
                blur: filter.blur,
                dx: filter.dx,
                dy: filter.dy,
                opacity: this.getDropShadowOpacity(filter.opacity),
                color: filter.color || '#000000',
            });
        },
        updateDropShadow($dropShadow, shadow) {
            var oldId = parseInt($dropShadow.attr("data-id"), 10),
                opacity = this.getDropShadowOpacity(shadow.opacity);

            if (oldId !== shadow.id) {
                $dropShadow.removeClass("filter_" + oldId).addClass("filter_" + shadow.id);
            }
            $dropShadow.find(".apply-flood-opacity").attr({
                "flood-opacity": opacity,
                "data-flood-opacity": opacity,
            });
            $dropShadow.find(".apply-flood-color").attr({
                "flood-color": shadow.color,
                "data-flood-color": shadow.color,
            });
            $dropShadow.find(".apply-shadow-blur").attr({
                "data-blur": shadow.blur,
            });
            $dropShadow.find(".apply-shadow-position").attr({
                "data-dx": shadow.dx,
                "data-dy": shadow.dy,
            });
        },
        updateContainerDropShadow($old, shadow) {
            if (!shadow || !shadow.id) {
                this.removeDropShadow($old);
                return;
            }
            if (shadow.id) {
                const $oldShadow = $old.find('.filter-drop-shadow'),
                    $oldShadowTextInit = $old.find('.text-content').css('text-shadow') === "none",
                    isTextContainer = Number($old.attr('data-container-type')) === Fotobook.ContainerType.CAPTION;

                if (!$oldShadow.length || (isTextContainer && $oldShadowTextInit)) {
                    this.appendDropShadow($old, shadow);
                } else {
                    this.updateDropShadow($oldShadow, shadow);
                }
            }
        },

        getFilterApplyClass(id) {
            return `filter-apply-${id}`;
        },
        onRemoveFilter() {
            const id = $(this).attr('id');
            if (id) {
                const cls = Fotobook.book.getFilterApplyClass(id);
                $(`.${cls}`).removeClass(cls).removeAttr('filter');
            }
        },
        removeFilter() {
            Fotobook.book.onRemoveFilter.call(this);
            this.remove();
        },
        removeDropShadow(e) {
            if (!(e instanceof jQuery)) {
                e = $(e);
            }
            const $filter = e.find('.filter-drop-shadow');
            if ($filter.length) {
                Fotobook.book.removeFilter.call($filter);
            }
            const isTextContainer = Number(e.attr('data-container-type')) === Fotobook.ContainerType.CAPTION,
                shadowTextInit = e.find('.text-content').css('text-shadow') !== "none";
            if(isTextContainer && shadowTextInit) {
                const attrs = Fotobook.book.dropShadowTextAttrs({});
                Object.keys(attrs).forEach(function (key) {
                    e.removeAttr(`data-${key}`);
                });
                Fotobook.book.recalcTextShadow.call(e);
            }
        },
        appendDropShadow($e, dropShadow) {
            if (!($e instanceof jQuery)) {
                $e = $($e);
            }

            if (Number($e.attr('data-container-type')) === Fotobook.ContainerType.CAPTION) {
                const attrs = Fotobook.book.dropShadowTextAttrs(dropShadow);
                Object.keys(attrs).forEach(function (key) {
                    const value = attrs[key];
                    $e.attr(`data-${key}`, value);
                });
                Fotobook.book.recalcTextShadow.call($e);
            } else {
                if (dropShadow instanceof Object) {
                    dropShadow = Fotobook.book.drawDropShadow(dropShadow);
                    Fotobook.book.removeDropShadow($e);
                }

                $e.each(function () {
                    const $this = $(this);
                    const $defs = $this.find('.defs')[0];
                    const id = Fotobook.book.getUniqueId();

                    // используем нативную функцию, так как jQuery добавляет не SVGElement, а HTMLElement, и всё ломается
                    $defs.append(dropShadow.supplant({
                        'drop_shadow-svg-id': id,
                    }));
                    $this.find('.apply-drop-shadow').attr('filter', `url(#${id})`).addClass(Fotobook.book.getFilterApplyClass(id));
                    Fotobook.book.recalcFilter_DropShadow.call($(document.getElementById(id)));
                });
            }
        },
    // --filters

        // применить фильтры/эффекты к контейнеру (яркость, контраст ...)
        applyContainerEffects(containers, params) {
            switch (this.haveToApplyEffects(containers, params)) {
                case true:
                    self.removeEffects(containers);
                    this.applyEffects(containers, params);
                    break;
                case false:
                    this.removeEffects(containers);
                    break;
                case undefined:
                    break;
            }
        },

        haveToApplyEffects(containers, params) {
            const paramsString = $(containers[0]).attr('data-filters');
            let paramsObject = {};
            if (paramsString) {
                paramsObject = JSON.parse(paramsString);
                if (params.brightness === paramsObject.brightness && params.contrast === paramsObject.contrast && params.saturation === paramsObject.saturation && params.filter === paramsObject.filter) {
                    return undefined; // пропустить применение фильтров
                }
            }

            return !(params.brightness === 1 && params.contrast === 1 && params.saturation === 1 && params.filter === '');
        },

        applyEffects($containers, params) {
            const effects = Fotobook.CompositeFilter.getContent(params);
            if (effects || params.filter) {
                const $group = $containers.find('.apply-mask');
                if (params.filter) {
                    $group.attr('filter', `url(#${params.filter})`);
                }
                if (effects) {
                    // jQuery преобразовывает имена тегов в нижний регистр :(
                    document.getElementById('predefinedFilters').insertAdjacentHTML('beforeend', effects);
                    const selectorName = Fotobook.CompositeFilter.getEffectSelectorName(params.id);
                    $group.find('.foto-image').attr('filter', `url(#${selectorName})`);
                }
                $containers.attr('data-filters', JSON.stringify(this.getEffectsContainersData(params)));
            }
        },

        getEffectsContainersData(params) {
            return {
                brightness: params.brightness ? params.brightness : Fotobook.CompositeFilter.DEFAULT_EFFECT_VALUE,
                contrast: params.brightness ? params.contrast : Fotobook.CompositeFilter.DEFAULT_EFFECT_VALUE,
                filter: params.filter ? params.filter : '',
                saturation: params.saturation ? params.saturation : Fotobook.CompositeFilter.DEFAULT_EFFECT_VALUE,
            };
        },

        removeEffects($containers) {
            const id = $containers.first().attr('data-id');
            const selectorName = Fotobook.CompositeFilter.getEffectSelectorName(id);
            $(`#${selectorName}`).remove();
            $containers
                .removeAttr('data-filters')
                .find('.apply-mask')
                .removeAttr('filter')
                .find('.foto-image')
                .removeAttr('filter');
        },

        drawGFXFrame(element) {
            let result = '';

            if (element.frame_id) {
                const frame_tmpl = '<image class="frame gfx-frame" xlink:href="{frame_path}?v={v}" data-id="{frame_id}" width="{width}%" height="{height}%" y="{top}%" x="{left}%" preserveAspectRatio="none" />';
                const inner_w = element.frame.x2 - element.frame.x1;
                const inner_h = element.frame.y2 - element.frame.y1;

                result = frame_tmpl.supplant({
                    frame_id: element.frame.id,
                    frame_path: Fotobook.createStorageUrl(element.frame.preview_path),
                    v: element.frame.version || 0,
                    width: 100 * element.frame.width / inner_w,
                    height: 100 * element.frame.height / inner_h,
                    top: -100 * (element.frame.y1 / inner_h),
                    left: -100 * (element.frame.x1 / inner_w),
                });
            }
            return result;
        },
        drawFigure(f, data) {
            let tpl = [];
            data = data || {};
            data.classes = data.classes || [];
            data.width = f.width;
            data.height = f.height;
            data.fill = data.fill || "none";
            data["figure-prefix"] = data["figure-prefix"] === undefined ? "" : data["figure-prefix"] + "-";
            switch (f.figure) {
                case "path":
                    tpl = ['<path {figure-prefix}d="{d}"'];
                    data["d"] = f.d.replace(/([a-zA-Z])(\d)/ig, "$1 $2");
                    break;

                case "polygon":
                    tpl = ['<polygon points="" {figure-prefix}points="{points}"'];
                    data["points"] = f.points;
                    break;

                case "rect":
                    tpl = ['<rect x="0" y="0" width="100%" height="100%" rx="{rx}%" data-rx="{rx}"'];
                    if (data.rx === undefined) {
                        data.rx = f.rx;
                    }
                    data.classes.push("apply-rx");
                    break;

                case "ellipse":
                case "circle":
                    tpl = ['<ellipse cx="50%" cy="50%" rx="50%" ry="50%"'];
                    break;

                default:
                    return "";
            }
            if (data.id) {
                tpl.push('id="{id}"');
            }
            if (data["data-id"]) {
                tpl.push('data-id="{data-id}"');
            }
            if (data.stroke_width) {
                tpl.push('stroke-width="{stroke_width}"');
                tpl.push('data-stroke_width="{data-stroke_width}"');
            }
            if (data.stroke_color) {
                tpl.push('stroke="{stroke_color}" data-stroke="{stroke_color}"');
            }
            if (data.stroke_opacity) {
                tpl.push('stroke-opacity="{stroke_opacity}" data-stroke-opacity="{stroke_opacity}"');
            }
            if (Fotobook.book["vector-effect"]) {
                tpl.push('vector-effect="non-scaling-stroke"');
            }

            tpl.push('data-width="{width}" data-height="{height}" fill="{fill}" data-fill="{fill}" class="{classes}" />');

            data.classes = data.classes.join(" ");
            return tpl.join(" ").supplant(data);
        },
        drawVectorFrame(e, dX) {
            if (!e.frame || e.frame.type != Fotobook.book.TYPE_VECTOR) {
                return "";
            }
            const params = {
                'stroke_color': e.stroke_color,
                'stroke_opacity': e.stroke_opacity / 100,
                'stroke_width': Fotobook.book.getSizeInEm(dX * e.stroke_width),
                'data-stroke_width': e.stroke_width,
                'classes': ['set-frame-stroke'],
            };

            if (Fotobook.book["vector-effect"] && (Fotobook.book._viewBoxFigures.indexOf(e.frame.figure) > -1)) {
                return [
                    '<svg class="frame frame-vector" data-id="{id}" width="100%" height="100%" preserveAspectRatio="none" viewBox="0 0 {frame_width} {frame_height}">',
                    Fotobook.book.drawFigure(e.frame, params),
                    '</svg>',
                ].join("").supplant({
                    "id": e.frame.id,
                    "frame_width": e.frame.width,
                    "frame_height": e.frame.height,
                });
            } else {
                params.classes.push("frame", "frame-vector");
                if (!Fotobook.book["vector-effect"]) {
                    params.classes.push("recalc-no-vector-effect");
                }
                return Fotobook.book.drawFigure(e.frame, $.extend(params, {
                    "data-id": e.frame.id,
                    "figure-prefix": "data",
                    "rx": e.rx,
                }));
            }
        },
        drawFrame(element, dX) {
            if (!element || !element.frame) {
                return "";
            } else if (element.frame.type == Fotobook.book.TYPE_VECTOR) {
                return Fotobook.book.drawVectorFrame(element, dX);
            } else if (element.frame.type == Fotobook.book.TYPE_GFX) {
                return Fotobook.book.drawGFXFrame(element);
            }
            return "";
        },
        /**
         * Считает размер картинки в фотоконтейнере по входным параметрам
         * Размеры картинки: data.foto_width, data.foto_height
         * Размеры отображаемой области (%): data.crop_width, data.crop_height
         * Размеры контейнера: data.cont_width, data.cont_height
         * @return Object - ширна и высота
         */
        getFotoCroppingSizes(data) {
            const bleed = data?.bleed ?? 0;
            const rotatedContRect = Fotobook.transforms.getRotatedBoundingBox(data.angle, data.cont_width + 2 * bleed, data.cont_height + 2 * bleed);
            const wCont = rotatedContRect.width;
            const hCont = rotatedContRect.height;

            const kFoto = data.foto_width / data.foto_height;
            const kCont = wCont / hCont;
            const kCrop = (data.crop_width * data.foto_width) / (data.crop_height * data.foto_height);
            let w;
            let h;

            if (kCrop > kCont) {
                h = hCont * 100 / data.crop_height;
                w = kFoto * h;
            } else {
                w = wCont * 100 / data.crop_width;
                h = w / kFoto;
            }

            // если из-за близости центра к краю возникают пустые области, необходимо увеличить изображение до их закрытия
            const cropCxInPixels = Math.min(data.crop_cx, 100 - data.crop_cx) * w / 100;
            const kx = Math.max(1, wCont / 2 / cropCxInPixels);

            const cropCyInPixels = Math.min(data.crop_cy, 100 - data.crop_cy) * h / 100;
            const ky = Math.max(1, hCont / 2 / cropCyInPixels);

            const k = Math.max(kx, ky);

            return {
                image_width: k * w,
                image_height: k * h,
            };
        },
        recalcFotoCropping() {
            if (this instanceof jQuery && this.length > 1) {
                this.each(function () {
                    Fotobook.book.recalcFotoCropping.call(this);
                });
                return;
            }
            const $this = (this instanceof jQuery ? this : $(this));

            if (!$this.attachedToDOM()) {
                return;
            }

            const selector = [];
            const $cont = $this.closest('.page-container');
            const contSize = $cont.computedSize();

            if (!$cont.hasClass('empty')) {
                selector.push('.foto-image');
            }
            if ($cont.hasClass('preview')) {
                selector.push('.foto-image-preview');
            }

            if (!$cont.length || !selector.length) {
                return;
            }

            const $img = $cont.find(selector.join(','));
            if (!$img?.length) {
                return;
            }

            const fs = Fotobook.book.getCurrentFontSize.call($cont);
            const bleed = fs * Fotobook.book.getClearSize(parseFloat($cont.attr('data-bleed')));
            const cont_width = contSize.width + 2 * bleed;
            const cont_height = contSize.height + 2 * bleed;
            const containerFotoAngle = Fotobook.book.getContainerFotoAngle($cont[0]);

            $img.each(function () {
                const $currentImg = $(this);
                const cropCx = Number($currentImg.attr('data-crop_cx') ?? 50);
                const cropCy = Number($currentImg.attr('data-crop_cy') ?? 50);
                const fotoOwnAngle = Fotobook.book.getFotoAngle(this);
                const cropping = Fotobook.book.getFotoCroppingSizes({
                    angle: containerFotoAngle + fotoOwnAngle,
                    cont_width,
                    cont_height,
                    foto_width: Number($currentImg.attr('data-width')),
                    foto_height: Number($currentImg.attr('data-height')),
                    crop_width: Number($currentImg.attr('data-crop_width') ?? 100),
                    crop_height: Number($currentImg.attr('data-crop_height') ?? 100),
                    crop_cx: cropCx,
                    crop_cy: cropCy,
                });
                $currentImg.attr({
                    x: `-${cropCx}%`,
                    y: `-${cropCy}%`,
                });
                $currentImg.closest('.set-image-size').attr({
                    width: `${cropping.image_width / fs}em`,
                    height: `${cropping.image_height / fs}em`,
                });
                $currentImg.siblings('.foto-image-cropping').attr({
                    x: $currentImg.attr('x'),
                    y: $currentImg.attr('y'),
                });
            });
        },
    // deep - устанавливаем в true, если это рекурсивный вызов
    // во время первого вызова выполняем массовые пересчёты, чтобы
    // минимизировать количество поисков
        recalcContainer_call(deep) {
            if (this instanceof jQuery && this.length > 1) {
                this.each(function () {
                    Fotobook.book.recalcContainer_call.call(this, deep);
                });
                return;
            }
            const $this = (this instanceof jQuery ? this : $(this)).closest('.page-container,.bg');

            if (!deep) {
                if (!Fotobook.book["vector-effect"]) {
                    $this.find(".recalc-no-vector-effect").each(function () {
                        Fotobook.book.recalcFigure.call(this);
                    });
                }
                $this.find(".filter").each(function () {
                    Fotobook.book.recalcFilter.call(this);
                });
    // Костыль для хрома: при ресайзе маски не растягиваются
    // Костыль для ФФ: не перерисовываются рамки при ресайзе (http://bt.web100.com.ua/view.php?id=49008)

                if ($.browser.webkit) {
                    $this.find(".set-frame-stroke,.root-svg-foto").each(function () {
                        this.setAttribute("width", "100.1%");
                        this.setAttribute("width", "100%");
                    });
                }
            }

            if ($this.hasClass("bg")) {
                const $image = $this.find('.bg-image');
                $this.toggleClass("bg-foto", $image.hasClass("bg-clipart-foto"));
                $this.toggleClass("bg-theme", $image.hasClass("bg-clipart-theme"));
                $this.toggleClass("bg-style", $image.hasClass("bg-style"));
            } else {
                switch (Number($this.attr('data-container-type'))) {
                    case Fotobook.ContainerType.GROUP:
                        Fotobook.book.recalcContainer_call.call($this.find(".group-content:first").children(), true);
                        break;

                    case Fotobook.ContainerType.FOTO:
                        const empty = $this.hasClass('empty');
                        if (!empty || $this.hasClass("preview")) {
                            Fotobook.book.recalcFotoCropping.call($this.find(".cropping"));
                        }
                        if (!empty) {
                            $this.toggleClass("controls-button-height", $this.hasClass("editor-container") && ($this.height() < 92)); // высота блока, при которой кнопки налезают на хендл обрезки (высота ручки кадрирования и две высоты кнопок)
                        } else {
                            Fotobook.book.fitEmptyFotoText($this);
                        }
                        break;

                    case Fotobook.ContainerType.CAPTION:
                        if ($this.hasClass("text-shadow")) {
                            Fotobook.book.recalcTextShadow.call($this);
                        }
                        break;

                    case Fotobook.ContainerType.CALENDAR:
                        Fotobook.book.recalcCalendarDateMarkRatio.call($this);
                        break;
                }
            }
            $this.trigger(Fotobook.events.RECALC_CONTAINER);
        },
        // пересчёт контейнера может запускаться разными событиями, при чём часто - в один и тот же "цикл перерисовки"
        // используем setTimeout, чтобы пересчёт выполнялся только один раз (экспериментально! возможны баги)
        recalcContainer() {
            if (this instanceof jQuery && this.length > 1) {
                this.each(function () {
                    Fotobook.book.recalcContainer.call(this);
                });
                return;
            }
            const $this = (this instanceof jQuery ? this : $(this)).closest('.page-container,.bg');
            if ($this.data("recalcContainer") === undefined) {
                $this.data("recalcContainer", setTimeout(() => {
                    $this.removeData("recalcContainer");
                    Fotobook.book.recalcContainer_call.call($this);
                }, 0));
            }
        },

        recalcAllElements() {
            Fotobook.book.recalcContainer_call.call($("#book:visible,#book-preview:visible").find(".top-level,.bg"));
            // создаётся большая нагрузка при слайдинге нижней панели фото/страниц

            Fotobook.store.dispatch('bottomPanel/updateControls');
            // Fotobook.bottomPanel.updateBottomControls();
        },

        getOpacity(element) {
            const opacity = Number(element.style.getPropertyValue('--container-opacity'));
            return Number.isFinite(opacity) ? opacity : 1;
        },
        setOpacity(el, opacity) {
            if (typeof el === 'string' || el instanceof HTMLElement || el instanceof SVGElement) {
                el = $(el);
            }
            el.each(function () {
                this.style.setProperty('--container-opacity', opacity);
                const widget = $(this).data('fotobook-containerEditor');
                if (widget) {
                    widget.update_control_opacity(opacity);
                }
            });
        },
        /**
         * возвращает SVG-атрибуты x,y и transform в зависимости от значения flipx/flipy
         * Причина, почему сделано это так:
         * - ИЕ вообще не понимает transform в CSS для SVG-элементов
         * - В вебките, если применить трансформацию к HTML-элементу внутри foreignObject,  на него
         *   перестают действовать фильтры (не отбрасывает тень)
         * - Для svg элементов начало координат для scale находится не в центре блока, а в [0,0], из-за
         *   чего необходимо дополнительно смещать элемент, а transform для svg-элементов не поддерживает
         *   значение в процентах, что не годится из-за необходимости постоянного пересчёта
         * - Значения атрибутов x и y не могут быть изменены с помощью css
         *
         */
        getFlipAttrs(flipx, flipy) {
            /*
             иногда приходит стринг "0" вместо false
             */
            flipx = (typeof flipx !== 'boolean') ? Boolean(Number(flipx)) : flipx;
            flipy = (typeof flipy !== 'boolean') ? Boolean(Number(flipy)) : flipy;

            var attrs = {
                    x: '0',
                    y: '0',
                    transform: '',
                },
                scale = [1, 1];

            if (flipx || flipy) {
                if (flipx) {
                    attrs.x = "-100%";
                    scale[0] = -1;
                }
                if (flipy) {
                    attrs.y = "-100%";
                    scale[1] = -1;
                }
                attrs.transform = "scale(" + scale.join(",") + ")";
            }
            return attrs;
        },
        recalcFlip(flipx, flipy) {
            this.find(".apply-flip").attr(Fotobook.book.getFlipAttrs(flipx, flipy));
        },
        setFrameStrokeWidth($el, width) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            const dX = parseFloat($el.closest('.book-page').attr('data-dx'));
            const frame = $el.find('.set-frame-stroke');
            frame.attr('data-stroke_width', width);
            frame.attr('stroke-width', Fotobook.book.getSizeInEm(dX * width));
        },
        setFramerx($el, rx) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            const applyRx = $el.find('.apply-rx');
            applyRx.each(function () {
                const self = $(this);
                self.attr('data-rx', rx);
                self.attr('rx', `${rx}%`);
            });
        },
        setContrx($el, rx) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            let mask = $el.find('.mask.mask-vector');
            if (!mask.length) {
                Fotobook.book.updateContainerMask_response($el, {
                    mask: {
                        figure: 'rect',
                        height: 1000,
                        width: 1000,
                        id: -1,
                        type: 1,
                        rx: 0,
                    },
                });
                mask = $el.find('.mask.mask-vector');
            }
            mask.find('.apply-rx').attr({
                'data-rx': rx,
                rx: `${rx}%`,
            });
        },
        setShadowOpacity($el, opacity) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            $el.find('.apply-flood-opacity').each(function () {
                this.setAttribute('flood-opacity', opacity);
            });
        },
        setShadowBlur($el, blur) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            $el.find('.apply-shadow-blur').each(function () {
                this.setAttribute('data-blur', blur);
                Fotobook.book.recalcFilter_DropShadow.call(this.parentNode);
            });
        },
        setShadowPosition($el, position) {
            if (!($el instanceof jQuery)) {
                $el = $($el);
            }
            $el.find('.apply-shadow-position').each(function () {
                this.setAttribute(position.prop, position.value);
                Fotobook.book.recalcFilter_DropShadow.call(this.parentNode);
            });
        },

        /**
         * получить размер шрифта в относительных еденицах em
         *
         * @param size размер в пикселях
         * @param round округлить значение до знака, 0 - не округлять
         * @returns {string}
         */
        getSizeInEm(size, round = 0) {
            let sizeInEm = this.getClearSize(size);
            if (round) {
                sizeInEm = Number(sizeInEm.toFixed(round));
            }
            return `${sizeInEm}em`;
        },

        /**
         * конвертировать размер шрифта в относительные еденицы em
         *
         * @param size
         * @returns {number}
         */
        getClearSize(size) {
            return size / Fotobook.book.BASE_SIZE;
        },

        getContainerSelector(id) {
            if (id instanceof Array) {
                id = id.join(",.cont_");
            }
            return id ? ".cont_" + id : "";
        },
        getElementSelector(element) {
            const selector = [];
            if ((element instanceof HTMLElement) || (element instanceof SVGElement)) {
                element = $(element);
            }
            element.each(function () {
                const $this = $(this);
                let containerSelector = '';
                if ($this.hasClass("bg")) {
                    containerSelector = ".page_" + $this.closes(".book-page").attr("data-id") + " .bg";
                } else {
                    containerSelector = Fotobook.book.getContainerSelector(this.getAttribute("data-id"));
                }
                if (containerSelector.length > 0) {
                    selector.push(containerSelector);
                }
            });
            return selector.join(",");
        },

        chrome_fixShadows() {
            // хром иногда почему-то обрезает тень по размеру контейнера
            if ($.browser.webkit) {
                $(Fotobook.book.book).find(".top-level").css("outline", "1px dashed transparent");
                setTimeout(function () {
                    $(Fotobook.book.book).find(".top-level").css("outline", "");
                }, 0);
            }
        },

        updateHtmlPageClasses($pages) {
            const single = Fotobook.book.single_page_mode;
            $("html")
                .toggleClass("flyleaf", Boolean($pages.filter(".flyleaf-page").length))
                .toggleClass("cover", Boolean($pages.filter(".cover").length))
                .toggleClass("page", Boolean($pages.filter(".page").length))
                .toggleClass("flyleaf-left", Boolean($pages.filter(".flyleaf-page.left").length))
                .toggleClass("flyleaf-right", Boolean($pages.filter(".flyleaf-page.right").length))
                .toggleClass("spread_count_1", single)
                .toggleClass("spread_count_2", !single)
                .toggleClass("spread_1_left", Boolean(single && $pages.filter(".left").length))
                .toggleClass("spread_1_right", Boolean(single && $pages.filter(".right").length))
                .toggleClass("h-page_even", Boolean(single && $pages.filter(".page_even").length))
                .toggleClass("h-page_odd", Boolean(single && $pages.filter(".page_odd").length))
                .toggleClass("booklet-product", Boolean(Fotobook.book.product.pages_spread_count - 1))
                .toggleClass("single-page-product", !(Fotobook.book.product.pages_spread_count - 1))
                .toggleClass("custom-substrate", Boolean(Fotobook.book.product.is_custom_substrate))
                .toggleClass("sheet-product", Boolean(Fotobook.book.product.fold_orientation))
            ;
        },

        regenerateUniqueIds(content) {
            const _map = {};
            return content.replace(/unique-id-(\d+)/g, (word, number) => {
                if (_map[number] === undefined) {
                    _map[number] = Fotobook.book.getUniqueId();
                }
                return _map[number];
            });
        },
        carouselContentToBook(content) {
            return Fotobook.book.regenerateUniqueIds(Fotobook.replaceSmallImagePath(content));
        },

        initPagesWrapperDroppable($element) {
            $element.droppable({
                accept($draggable) {
                    if ($draggable.is('.img-page-layout, .album-image-draggable, .cover-layout, .collage-layout')) {
                        return true;
                    }
                    if ($draggable.data('new-text-container') || $draggable.data('new-foto-container') || $draggable.data('artefact') || $draggable.data('calendar')) {
                        return true;
                    }
                    return false;
                },
                tolerance: 'touch',
                drop(event, ui) {
                    if (ui.helper.hasClass('album_image') && $('.img-over-container').length) {
                        return;
                    }
                    // маркируем, что хелпер уже обработан, чтобы другие возможные droppable его не принимали
                    if (ui.helper.data('dropped')) {
                        return;
                    }
                    ui.helper.data('dropped', '1');

                    const $page = Fotobook.book.getPageByPixel(event.clientX);
                    const instant = Fotobook.store.getters['OnlineEditor/editMode'].code === Fotobook.EditModeCode.INSTANT;
                    const artefact = ui.draggable.data('artefact');
                    const calendar = ui.draggable.data('calendar');
                    const newTextContainer = ui.draggable.data('new-text-container');
                    const newFotoContainer = ui.draggable.data('new-foto-container');

                    if (!($page instanceof jQuery)) {
                        return;
                    }

                    const isCover = $page.hasClass('cover');

                    if (isCover) {
                        if (Fotobook.book.cover.foto_layout && ui.draggable.hasClass('cover-layout')) {
                        } else if (Fotobook.book.cover.foto_clipart && ui.draggable.hasClass('img-page-layout')) {
                        } else if (!Fotobook.book.cover.foto_clipart) {
                            if (ui.draggable.hasClass('img-page-layout')) {
                                Fotobook.notification.showWarning(window.t('photobook-js-messagePageLayoutForPages'));
                            } else {
                                Fotobook.notification.showWarning(window.t('photobook-js-error-cannotPlaceElementsOnCover'));
                            }
                            return;
                        }
                    }
                    if ($page.hasClass('flyleaf-page') && (ui.draggable.is('.album-image-draggable') || artefact || calendar || newTextContainer || newFotoContainer)) {
                        Fotobook.notification.showWarning(window.t('photobook-js-error-cannotPlaceElementsOnFlyleaf'));
                        return;
                    }

                    if (ui.draggable.hasClass('cover-layout')) {
                        Fotobook.pageLayout.selectCoverLayout(ui.draggable.attr('data-id'), $page);
                    } else if (ui.draggable.hasClass('img-page-layout') || ui.draggable.hasClass('collage-layout')) {
                        if (Fotobook.checkValidPage($page)) {
                            Fotobook.pageLayout.selectPageLayout(ui.helper.attr('data-id'), $page);
                        }
                    } else if (artefact) {
                        Fotobook.newContainer.dropNewContainer($page, ui, Fotobook.ContainerType.ARTEFACT);
                    } else if (calendar) {
                        Fotobook.newContainer.dropNewContainer($page, ui, Fotobook.ContainerType.CALENDAR);
                    } else if (newTextContainer) {
                        Fotobook.newContainer.dropNewContainer($page, ui, Fotobook.ContainerType.CAPTION);
                    } else if (ui.draggable.hasClass('album-image-draggable')) {
                        if (!instant) {
                            const photoId = ui.draggable.find('.album_image').attr('data-id');
                            Fotobook.warnIfAlreadyUsed(photoId);

                            // нужно сохранить координаты хелпера до того, как появится диалог;
                            // иначе координаты контейнера посчитаются неправильно
                            const helperBox = ui.helper[0].getBoundingClientRect();

                            const $dialog = Fotobook.dialog.choose(window.t('photobook-js-moveFotoToBgPageOrContainer'), {
                                title: window.t('photobook-js-moveFotoToBgPageOrContainerTitle'),
                                buttons: [
                                    {
                                        class: 'fotobook_button functional-button',
                                        text: window.t('photobook-js-container'),
                                        click: async () => {
                                            await Fotobook.newContainer.dropNewContainer($page, ui, Fotobook.ContainerType.FOTO, { helperBox });
                                            Fotobook.dialog.close($dialog);
                                        },
                                    },
                                    {
                                        class: 'fotobook_button functional-button',
                                        text: window.t('photobook-js-bgPage'),
                                        click: () => {
                                            Fotobook.pageBackground.changePageBackgroundDialog({
                                                // eslint-disable-next-line camelcase
                                                background_id: 0,
                                                // eslint-disable-next-line camelcase
                                                foto_id: photoId,
                                            });

                                            // не накладываем несколько диалогов друг поверх друга
                                            Fotobook.dialog.close($dialog);
                                        },
                                    },
                                ],
                            });
                        } else {
                            Fotobook.notification.showWarning(window.t('photobook-js-dropFoto-warning'));
                        }
                    } else if (newFotoContainer && !instant) {
                        Fotobook.newContainer.dropNewContainer($page, ui, Fotobook.ContainerType.FOTO);
                    }
                },
            });
        },
        initCurrentSpread() {
            const $book = $(Fotobook.book.book);
            this.initPagesWrapperDroppable($book.find('.pages-wrapper'));
            Fotobook.pageBackgroundDroppable.initBackgroundDroppable($book.find('.bg-drop-accept'));
        },

        drawCurrent() {
            const currentPage = Fotobook.store.getters['OnlineEditor/currentPage'];
            const $book = $(Fotobook.book.book);
            const $spread = $(Fotobook.book.pagesList)
                .find(`.book-page[data-page_num=${currentPage}]`)
                .closest('.pages-wrapper');
            const $pages = $spread.find('.book-page');

            if (!$book.length || !$spread.length) {
                return;
            }
            const content = Fotobook.book.carouselContentToBook($spread[0].outerSVG);
            $book.find('.pages-wrapper').remove();
            $book.prepend(content);
            const pages = Fotobook.store.state.OnlineEditor.pages;
            this.currentSpread = $pages.toArray().map((page) => pages[page.getAttribute('data-id')]);
            Fotobook.book.updateHtmlPageClasses($pages);
            Fotobook.resizeWorkspace($(Fotobook.book.book));

            $(document).triggerHandler(Fotobook.events.CHANGE_PAGE, currentPage);
            Fotobook.book.chrome_fixShadows();

            // TODO вынести и использовать всё, что касается активной страницы, через vuex
            Fotobook.store.commit('OnlineEditor/setCurrentSpread', this.currentSpread);

            this.initCurrentSpread();
        },

        checkBookletButtons(current, total) {
            const $next = $('.book-button-preview.next');
            const $prev = $('.book-button-preview.prev');
            const disablePrev = current === 0;
            const disableNext = current >= total - 1;

            $prev.toggleClass('disabled', disablePrev);
            $next.toggleClass('disabled', disableNext);
            $prev.add($next).css('display', disableNext && disablePrev ? 'none' : '');
        },

        updateSupplantStyles(element, vars) {
            element.add(element.find('*')).each(function () {
                if (this.hasAttribute("data-style")) {
                    this.setAttribute("style", this.getAttribute("data-style").supplant(vars));
                }
                if (this.hasAttribute("data-src")) {
                    this.setAttribute("src", this.getAttribute("data-src").supplant(vars));
                }
            });
        },

        /**
         * Изменить размер текста ("Drop your photo here") в масштабируемом пустом контейнере
         *
         * @param {object} $container Контейнер в котором будет менятся размер текста
         */
        fitEmptyFotoText($container) {
            if ($container === undefined) {
                $container = $(Fotobook.book.book).find(".foto-container");
            } else if (typeof $container === "number") {
                $container = $(Fotobook.book.book).find(Fotobook.book.getContainerSelector($container));
            } else if ($container instanceof Element) {
                $container = $($container);
            }
            if ($container instanceof jQuery) {
                $container.each(function () {
                    Fotobook.textFitToParent.call(this, Fotobook.book.BASE_SIZE);
                });
            }
        },

        cannotSwapPages() {
            Fotobook.dialog.alert(window.t("photobook-js-cantReplace-text"), {
                title: window.t("photobook-js-cantReplace-title"),
            });
        },
        clearPage($pages) {
            const ids = [];

            $pages.each(function () {
                ids.push(parseInt(this.getAttribute("data-id"), 10));
            });

            if (!ids.length || !$pages.length) {
                return;
            }
            // Fotobook.pages.clearPage(ids);
            Fotobook.store.dispatch('OnlineEditor/clearPage', ids);
        },
        saveProjectMessage(msg) {
            return Fotobook.dialog.alert(msg, {
                title: window.t("photobook-js-saveProjectDialogTitle"),
                width: 400,
                buttonResolve: window.t("photobook-js-buttonsClose"),
                resolved: !msg || !msg.length,
            });
        },
        /**
         * @param elements string|jQueryObject
         * @param css - объект с сохраняемыми свойствами
         */
        setContainerStyle($elements, data) {
            var applycss = {},
                applyattrs = {},
                applyfotoattrs = {},
                attrs_foto_map = {
                    cx: 'data-crop_cx',
                    cy: 'data-crop_cy',
                    crop_width: 'data-crop_width',
                    crop_height: 'data-crop_height',
                },
                $img,
                $page,
                dX, k;
            if (!($elements instanceof jQuery)) {
                $elements = $($elements);
            }
            if ($elements.hasClass("foto-container")) {
                $img = $elements.find(".foto-image");
            }

            if (data.page_id) {
                const pageClass = `.page_${data.page_id}`;
                $elements.each(function () {
                    var $old = $(this),
                        $old_page = $old.closest(".book-page"),
                        page_id = parseInt($old_page.attr("data-id"), 10),
                        $new_page;

                    if (data.page_id == page_id) {
                        $page = $old_page;
                        return;
                    }

                    $new_page = $old_page.closest([Fotobook.book.book, Fotobook.book.pagesList].join(",")).find(pageClass);
                    if (!$new_page.length) {
                        Fotobook.book.removeContainer($old);
                    } else {
                        const $wrapper = $(self.wrapContainer($.extend({
                            content: '',
                        }, self.getContainerWrapData($new_page))));
                        const $oldWrapper = $old.closest('.cont-wrapper');

                        $wrapper.find(".append-content").append($old);
                        $new_page.find(".append-containers").append($wrapper);
                        $oldWrapper.remove();
                        $page = $new_page;
                    }
                });
            } else {
                $page = $elements.closest(".book-page");
            }
            if (!$page.length) {
                return;
            }
            dX = parseFloat($page.attr("data-dx"));
            k = Fotobook.book.getPagePixelK($page);

            for (const style in data) {
                if (!Object.prototype.hasOwnProperty.call(data, style)) {
                    continue;
                }
                if (["top", "left", "right", "bottom", "width", "height"].indexOf(style) > -1) {
                    var suffix = (data[style] + "").match(/em$|px$/),
                        value = parseFloat(data[style]),
                        attrvalue;

                    if (!(suffix instanceof Array)) {
                        applycss[style] = Fotobook.book.getSizeInEm(dX * value);
                        attrvalue = value;
                    } else if (suffix[0] === "em") {
                        applycss[style] = data[style];
                        attrvalue = value * Fotobook.book.BASE_SIZE / dX;
                    } else if (suffix[0] === "px") {
                        applycss[style] = Fotobook.book.getSizeInEm(dX * k * value);
                        attrvalue = k * value;
                    }
                    if (["width", "height"].indexOf(style) > -1) {
                        applyattrs[`data-${style}`] = attrvalue;
                    }
                } else if (style === 'angle') {
                    Object.assign(applycss, this.getContainerAngleVars(data.angle));
                } else if (style === "zIndex") {
                    $elements.data("zindex", data[style]);
                    applycss[style] = Fotobook.book.getZindexCSS(data[style]);
                } else if (["crop_width", "crop_height", "cx", "cy"].indexOf(style) > -1) {
                    applyfotoattrs[attrs_foto_map[style]] = data[style];
                } else if (["data-width", "data-height"].indexOf(style) > -1) {
                    applyattrs[style] = data[style];
                }
            }
            $elements.css(applycss).attr(applyattrs);
            if ($img) {
                $img.attr(applyfotoattrs);
            }

            // метод будет вызван позже 6.12.2017
            // Fotobook.book.recalcContainer.call($elements);
            return $elements;
        },
        // todo выделить в отдельный компонент и сделать полноценное обновление рамки
        // todo разделить обновление векторной и растровой рамок
        updateContainerFrame_response($old, cont) {
            if (!cont.frame || !cont.frame.id) {
                this.removeFrame($old);
                return;
            }
            var $frame = $old.find(".frame"),
                frame_id = parseInt($frame.attr("data-id"), 10),
                frame_rx = parseInt($frame.attr("data-rx"), 10),
                frame_stroke_width = parseInt($frame.attr("data-stroke_width"), 10);

            // если что-то в рамке поменялось...
            if (cont.frame.id != frame_id ||
                frame_rx != cont.frame.rx ||
                frame_stroke_width != cont.stroke_width ||
                cont.stroke !== $frame.attr("data-stroke")
            ) {
                this.appendFrame($old, this.drawFrame(cont, $old.getDx()));
            }
            Fotobook.qualityCheck.checkContainerQuality(cont);
        },
        updateContainerMask_response($old, cont) {
            if (!cont.mask || !cont.mask.id) {
                if (!cont.rx) {
                    Fotobook.book.removeMask($old);
                }
                return;
            }

            var mask = $old.find(".mask"),
                mask_id = parseInt(mask.attr("data-id"), 10),
                mask_rx = parseInt(mask.find(".apply-rx").attr("data-rx"), 10);

            //если поменялась маска или радиус скругления контейнера
            if (cont.mask.id != mask_id || mask_rx != cont.rx) {
                mask = Fotobook.book.drawMask(cont);
                Fotobook.book.removeMask($old);

                $old.each(function () {
                    var $this = $(this),
                        defs = $this.find(".defs")[0],
                        id = Fotobook.book.getUniqueId();
                    defs.append(mask.supplant({
                        "mask-svg-id": id,
                    }));
                    $this.find(".apply-mask").attr("mask", "url(#" + id + ")");
                });
            }
            Fotobook.qualityCheck.checkContainerQuality(cont);
        },
        updateContainerFromResponse($old, cont, params) {
            if (cont.page_id && $old.hasClass('top-level')) {
                Fotobook.book.setContainerStyle($old, {
                    page_id: cont.page_id,
                    left: cont.x,
                    top: cont.y,
                    width: cont.width,
                    height: cont.height,
                    angle: cont.angle,
                });
            }
            Fotobook.book.setOpacity($old, cont.opacity / 100);

            switch (cont.type) {
                case Fotobook.ContainerType.FOTO:
                    Fotobook.book.setContainerImage_response(cont);
                    Fotobook.book.updateContainerFrame_response($old, cont);
                    Fotobook.book.updateContainerMask_response($old, cont);
                    Fotobook.book.updateContainerDropShadow($old, cont.drop_shadow);
                    Fotobook.book.applyContainerEffects($old, cont);
                    break;

                case Fotobook.ContainerType.ARTEFACT:
                    $old.toggleClass('flipx', Boolean(Number(cont.flipx)));
                    $old.toggleClass('flipy', Boolean(Number(cont.flipy)));
                    Fotobook.book.updateContainerDropShadow($old, cont.drop_shadow);
                    break;

                case Fotobook.ContainerType.CAPTION:
                    Fotobook.book.updateContainerDropShadow($old, cont.drop_shadow);
                    break;

                case Fotobook.ContainerType.CALENDAR:
                    Fotobook.containers.calendar.updater.updateFromResponse($old, cont);
                    break;
            }

            if (cont.type !== Fotobook.ContainerType.BG) {
                $old.css(this.getZindexVars(cont.z_index));
            }

            Fotobook.book.recalcContainer.call($old);
            $old.add($old.find(".page-container.editing")).each(function () {
                const widget = $(this).data('fotobook-containerEditor');
                if (widget) {
                    widget.checkButtons();
                    widget.updateToolbarPosition();
                }
            });
        },
        updateBgImage_responce_check($image, page) {
            const bgc = page.background;
            const imageId = Number($image.attr('data-id'));
            if (bgc.foto_id !== imageId) {
                return true;
            }
            if (bgc.foto) {
                if ($image.hasClass("bg-clipart-foto") || (bgc.foto_position != parseInt($image.attr("data-foto_position"), 10))) {
                    return true;
                }
                for (let i = 0; i < Fotobook.book._crop_attrs.length; i++) {
                    if ($image.attr("data-" + Fotobook.book._crop_attrs[i]) != bgc[Fotobook.book._crop_attrs[i]]) {
                        return true;
                    }
                }
            } else {
                if (!$image.hasClass("bg-clipart-theme")) {
                    return true;
                }
            }

            return false;
        },
        updateBgImage_responce($image, page) {
            if (Fotobook.book.updateBgImage_responce_check($image, page)) {
                var $parents = $image.parent(),
                    image = Fotobook.book.drawPageBackgroundImage(page),
                    image_book = Fotobook.replaceSmallImagePath(image);
                $image.add($image.siblings(".bounding-box")).remove();
                $parents.each(function () {
                    this.append($(this).closest(Fotobook.book.book).length ? image_book : image);
                });
            }
        },
        updateBgFromResponse(page) {
            if (!Fotobook.book.cover.foto_clipart && page.type === Fotobook.PageType.COVER) {
                return;
            }

            var cont = page.background,
                $old = $(".cont_" + cont.id),
                widget = $old.data("fotobook-containerEditor"),
                $image = $old.find(".bg-image");
            if (!cont.foto_id && !cont.background_id) {
                $image.remove();
                $old.find("defs").empty();
            } else if (!$image.length) {
                const new_data = Fotobook.book.drawPageBackground(page);
                Fotobook.book.appendBg(`.page_${page.id}`, new_data);
            } else {
                Fotobook.book.updateBgImage_responce($image, page);
                Fotobook.book.updateContainerMask_response($old, cont);
                Fotobook.book.setOpacity($old, cont.opacity / 100);
            }
            setTimeout(() => Fotobook.book.recalcContainer.call($old), 10);
            if (widget) {
                // Задержка нужна, чтобы успел обновиться класс .bg-spread
                setTimeout(function () {
                    if (widget.element.attachedToDOM()) {
                        widget._checkButtons();
                        widget.updateToolbarPosition();
                    } else {
                        $(Fotobook.book.book).find(".cont_" + cont.id).containerEditor();
                    }
                }, 10);
            }
        },
        /**
         *  Обновить содержимое книги в зависимости от ответа сервера (добавить/удалить контейнер(ы))
         *
         * @param response
         * @param params
         */
        updateBookFromResponse(response, params) {
            let idx;
            if (response.remove) {
                for (idx = 0; idx < response.remove.length; idx++) {
                    Fotobook.book.removeContainer(response.remove[idx]);
                }
            }

            let containers_added = false;
            for (idx in response.containers ?? {}) {
                if (!Object.prototype.hasOwnProperty.call(response.containers, idx)) {
                    continue;
                }
                const cont = response.containers[idx];
                if (cont.type === Fotobook.ContainerType.SPINE) {
                    cont.content = $("#spineEditor").find(".text-content").text();
                    Fotobook.book.appendSpine(cont);
                    continue;
                }

                const $old = $(Fotobook.book.getContainerSelector(cont.id));
                const data = $old.data("fotobook-initial");
                // Если ответ на действие пришёл после того, как новое действие начато - ничего не делаем
                if (data && cont.move_started && cont.move_started < data.time) {
                    continue;
                }
                if ($old.length) {
                    Fotobook.book.updateContainerFromResponse($old, cont, params);
                } else if (cont.page_id) {
                    containers_added = true;
                    Fotobook.book.addContainerToPage(cont);
                }
            }
    // http://bt.web100.com.ua/view.php?id=50544
            if (containers_added) {
                const e = $.Event('EntwineElementsAdded');
                e.targets = [];
                $(document).trigger(e);
            }
    // -------------------------------------------------------------------------------------------
            if (response.pages) {
                const page_ids = [];
                for (idx in response.pages) {
                    if (Object.prototype.hasOwnProperty.call(response.pages, idx)) {
                        Fotobook.book.updateBgFromResponse(response.pages[idx]);
                        page_ids.push(response.pages[idx].id);
                    }
                }
                $(".page_" + page_ids.join(",.page_")).closest(".pages-wrapper").each(function () {
                    Fotobook.book.updateBgSpread(this);
                });
            }

            const widget = Fotobook.book.getSelectionWidget();
            if (!$(".page-container.selected").length) {
                if (widget) {
                    widget.destroy();
                }
            } else {
                widget.updateToolbarPosition();
            }

            $(document).triggerHandler(Fotobook.events.PROJECT_CONTENT_CHANGED);
        },

        /** сохраняем начальные координаты, чтобы потом в случае необходимости восстановить их */
        backupInitialCoordinates($cont, affected_coords) {
            var style = $cont[0].style;
            const page_id = parseInt($cont.closest('.book-page').attr('data-id'), 10);
            const init = {
                top: style.top,
                left: style.left,
                width: style.width,
                height: style.height,
                angle: this.getContainerAngle($cont[0]),
                'data-width': $cont.attr('data-width'),
                'data-height': $cont.attr('data-height'),
            };
            var data = {
                page_id,
                time: Date.now(),
            };
            var c;
            if ($cont.hasClass("foto-container")) {
                const $img = $cont.find('.foto-image');
                Object.assign(init, {
                    cx: $img.attr('data-crop_cx'),
                    cy: $img.attr('data-crop_cy'),
                    crop_width: $img.attr('data-crop_width'),
                    crop_height: $img.attr('data-crop_height'),
                });
            }
            for (let i = 0, l = affected_coords.length; i < l; i++) {
                c = affected_coords[i];
                data[c] = init[c];
            }
            $cont.data("fotobook-initial", data);
        },
        restoreInitialCoordinates($cont, init_data) {
            $cont.each(function () {
                let data = init_data;
                const $this = $(this);
                if (!data) {
                    data = $this.data("fotobook-initial");
                    $this.removeData("fotobook-initial");
                }
                if (data) {
                    Fotobook.book.setContainerStyle($this, data);
                    $this.trigger("update-container-toolbar");
                }
            });
        },
        SAVE_POSITION_OUTSIDE_BOOK: 1,
        SAVE_POSITION_ON_FLYLEAF: 2,
        getSavedPositionParams($cont, affected_coords) {
            var $originalPage = $cont.closest(".book-page"),
                initialData = $cont.data("fotobook-initial"),
                cont = $cont[0],
                contBbox = cont.getBoundingClientRect(),
                params = {},
                new_coords = {},
                position = $.extend({
                    top: parseFloat($cont.css("top")),
                    left: parseFloat($cont.css("left")),
                    angle: this.getContainerAngle($cont[0]),
                }, $cont.computedSize()),
                pages = [],
                newPage, k
                ;

            $cont.closest(".pages-wrapper").find(".book-page").each(function () {
                var $page = $(this),
                    pageBbox = this.getBoundingClientRect(),
                    pageMargins = {
                        left: parseFloat($page.css("marginLeft")) || 0,
                        right: parseFloat($page.css("marginRight")) || 0,
                        top: parseFloat($page.css("marginTop")) || 0,
                        bottom: parseFloat($page.css("marginBottom")) || 0,
                    }
                    ;
                if (
                    (contBbox.bottom < pageBbox.top    - pageMargins.top) ||
                    (contBbox.top    > pageBbox.bottom + pageMargins.bottom) ||
                    (contBbox.right  < pageBbox.left   - pageMargins.left) ||
                    (contBbox.left   > pageBbox.right  + pageMargins.right)
                ) {
                    return;
                }

                pages.push({
                    page: $page,
                    box: pageBbox,
                    margins: pageMargins,
                });
            });
            if (!pages.length) {
                return Fotobook.book.SAVE_POSITION_OUTSIDE_BOOK;
            }
            pages = pages.filter(function (obj) {
                return !obj.page.hasClass("flyleaf-page");
            });
            if (!pages.length) {
                return Fotobook.book.SAVE_POSITION_ON_FLYLEAF;
            }

            newPage = pages.find(function (obj) {
                return obj.page[0] === $originalPage[0];
            });

            // Если дропнули в пределах той же страницы
            if (newPage) {
                k = Fotobook.book.getPagePixelK(newPage.page);
                if (affected_coords.indexOf("left") > -1) {
                    params.x = k * position.left;
                }
                if (affected_coords.indexOf("top") > -1) {
                    params.y = k * position.top;
                }
            } else {
                const originalBox = $cont.closest('.book-page')[0].getBoundingClientRect();
                newPage = pages[0];
                k = Fotobook.book.getPagePixelK(newPage.page);
                params.x = k * (position.left + originalBox.left - newPage.box.left);
                params.y = k * (position.top + originalBox.top - newPage.box.top);
            }
            params.page_id = parseInt(newPage.page.attr("data-id"), 10);

            new_coords = {
                page_id: params.page_id,
                left: params.x,
                top: params.y,
            };
            if (affected_coords.indexOf("width") > -1) {
                new_coords.width = params.width = k * position.width;
            }
            if (affected_coords.indexOf("height") > -1) {
                new_coords.height = params.height = k * position.height;
            }
            if (affected_coords.indexOf("angle") > -1) {
                params.angle = position.angle;
            }
            Fotobook.book.setContainerStyle($cont, new_coords);
            if (initialData) {
                params.move_started = initialData.time;
            }
            return params;
        },

        /**
         * сохранить новую позицию для перемещенного контейнера
         * @param $cont
         * @param affected_coords
         * @param additionalParams
         */
        saveContainerPositionSingle($cont, affected_coords, additionalParams = {}) {
            const data = Fotobook.book.getSavedPositionParams($cont, affected_coords);

            if (typeof data === "number") {
                if (data === Fotobook.book.SAVE_POSITION_OUTSIDE_BOOK) {
                    Fotobook.book.removeContainerConfirmation($cont).then(() => {
                        setTimeout(() => {
                            // todo вероятно, некорректно скрывать!!!
                            $cont.hide();
                            Fotobook.book.removeContainersSend($cont);
                        }, 0);
                    }).catch(() => {
                        Fotobook.book.restoreInitialCoordinates($cont);
                    });
                } else if (data === Fotobook.book.SAVE_POSITION_ON_FLYLEAF) {
                    Fotobook.book.restoreInitialCoordinates($cont);
                    Fotobook.notification.showWarning(window.t('photobook-js-error-cannotPlaceElementsOnFlyleaf'));
                }
            } else {
                const id = parseInt($cont.attr('data-id'), 10);
                const params = {};

                $cont.add($cont.find(".page-container")).removeClass("safe-area-detected");
                if ($cont.hasClass("text-container")) {
                    data.text_content_ratio = self.getTextContentRatio($cont);
                }
                params[id] = {
                    ...data,
                    ...additionalParams,
                };
                Fotobook.containers.changeContainerAttrs(params);
            }
        },

        swapTextContainerHeight($container, callback) {
            const $content = $($container.find('.redactor-editor')[0] || $container.find('.text-content')[0]);

            if (!$content.length) {
                return undefined;
            }

            // сбрасываем параметры, которые могут придавать высоту содержимому
            return jQuery.swap($container[0], {
                height: 0,
                'min-height': 0,
                bottom: 'auto',
            }, function () {
                return callback.call(this, $content);
            });
        },
        /** получить соотношение размеров текстового содежимого контейнера */
        getTextContentRatio($container) {
            return self.swapTextContainerHeight($container, function ($content) {
                const size = $content.computedSize();
                if (!size.width || !size.height) {
                    return undefined;
                }
                return size.width / size.height;
            });
        },
        getTextContainerMinHeight($container) {
            return self.swapTextContainerHeight($container, function ($content) {
                return $content.height();
            }) || 1;
        },

        /**
         * сохранить новую позицию для группы перемещенных контейнеров
         * @param $cont
         * @param affected_coords
         * @param additionalParams
         */
        saveContainerPositionMultiple($cont, affected_coords, additionalParams = {}) {
            var params = {},
                removingCont = [];

            $cont.each(function () {
                var $this = $(this),
                    id = parseInt($this.attr("data-id"), 10),
                    data = Fotobook.book.getSavedPositionParams($this, affected_coords);
                if (typeof data == "number") {
                    //если объект выходит за область видимости книги добавляем его в отдельный масив
                    if (data == Fotobook.book.SAVE_POSITION_ON_FLYLEAF) {
                        // если хотябы оди объект все еще на форзаце то группу не удалять, а вернуть все на место
                        Fotobook.book.restoreInitialCoordinates($cont);
                        Fotobook.notification.showWarning(window.t('photobook-js-error-cannotPlaceElementsOnFlyleaf'));
                        return false;
                    }
                    removingCont.push($this.get(0));
                } else {
                    params[id] = {
                        ...data,
                        ...additionalParams,
                    };
                }
            });
            if (removingCont.length > 0) {
                //если есть объекты в списке на удаление вызываем диалог
                removingCont = $(removingCont);
                Fotobook.book.removeContainerConfirmation(removingCont).then(() => {
                    //удаляем все объекты вне области видимости
                    setTimeout(() => {
                        removingCont.hide();
                        Fotobook.book.removeContainersSend(removingCont);
                    }, 0);
                }).catch(() => {
                    Fotobook.book.restoreInitialCoordinates($cont);
                });
            }
            $cont.add($cont.find(".page-container")).removeClass("safe-area-detected");
            Fotobook.containers.changeContainerAttrs(params);
        },

        saveContainerPosition($cont, affectedCoords, additionalParams) {
            if ($cont.length > 1) {
                return Fotobook.book.saveContainerPositionMultiple($cont, affectedCoords, additionalParams);
            } else {
                return Fotobook.book.saveContainerPositionSingle($cont, affectedCoords, additionalParams);
            }
        },
        saveContainerPositionFotoOnBg($cont, affected_coords, additionalParams = {}) {
            if (!$cont.hasClass("foto-container") || $cont.hasClass("empty") || $cont.hasClass("no-original")) {
                Fotobook.book.saveContainerPosition($cont, affected_coords, additionalParams);
                return;
            }

            var box = $cont[0].getBoundingClientRect(),
                foto_id = parseInt($cont.find(".foto-image").attr("data-id"), 10),
                $bgs = $(Fotobook.book.book).find(".bg"),
                bg_ids = [],
                containers = {};

            $bgs.each(function () {
                var bgbox = this.getBoundingClientRect(),
                    fluff = 0.02 * bgbox.width,
                    id = parseInt($(this).find(".bg-content").attr("data-id"), 10);
                if (
                    id &&
                    (box.top - fluff < bgbox.top) &&
                    (box.bottom + fluff > bgbox.bottom) &&
                    (box.left - fluff < bgbox.left) &&
                    (box.right + fluff > bgbox.right)
                ) {
                    bg_ids.push(id);
                }
            });
            if (!bg_ids.length || !foto_id) {
                Fotobook.book.saveContainerPosition($cont, affected_coords);
                return;
            }
            for (let i = 0; i < bg_ids.length; i++) {
                containers[bg_ids[i]] = {
                    foto_id,
                    mask_id: 0,
                    foto_position: bg_ids.length > 1 ? Fotobook.FotoPosition.HALF : Fotobook.FotoPosition.FULL,
                };
            }
            containers[parseInt($cont.attr("data-id"), 10)] = Fotobook.book.COMMAND_REMOVE;

            Fotobook.dialog.confirm(window.t(bg_ids.length === 2 ? "photobook-js-moveFotoToBgSpread" : "photobook-js-moveFotoToBgPage"), {
                title: window.t("photobook-js-moveFotoToBgTitle"),
            }).then(() => {
                Fotobook.containers.changeContainerAttrs(containers).catch(() => {
                    Fotobook.book.restoreInitialCoordinates($cont);
                });
            }).catch(() => {
                Fotobook.book.saveContainerPosition($cont, affected_coords);
            });
        },
        _viewBoxFigures: ["polygon", "path"],
        _mask_tpl: [
            '<defs class="mask mask-vector" data-id="{id}" data-figure="{figure}">',
                '<svg id="{use-id}" width="100%" height="100%" {viewBox} preserveAspectRatio="none">',
                    '{mask-content}',
                '</svg>',
                '<mask id="{mask-svg-id}" maskUnits="userSpaceOnUse">',
                    '<use class="mask-position" xlink:href="#{use-id}" />',
                '</mask>',
            '</defs>',
        ].join(""),
        _mask_image_tpl: '<image class="mask-image webkit-fix-mask" x="0" y="0" width="100%" height="100%" preserveAspectRatio="none" xlink:href="{mask-img-path}?version={v}" />',
        drawMask(el) {
            if (!(el && el.mask && el.mask.id)) {
                return '';
            }
            const params = {
                id: el.mask.id,
                figure: el.mask.figure,
                viewBox: '',
                "use-id": Fotobook.book.getUniqueId(),
            };

            if (el.mask.type == Fotobook.book.TYPE_GFX) {
                params["mask-content"] = Fotobook.book._mask_image_tpl.supplant({
                    "mask-img-path": Fotobook.createStorageUrl(el.mask.preview_path),
                    v: el.mask.version || 0,
                });
            } else {
                if (Fotobook.book._viewBoxFigures.indexOf(el.mask.figure) > -1) {
                    params.viewBox = ['viewBox="0 0 ', el.mask.width, ' ', el.mask.height, '"'].join('');
                }
                params["mask-content"] = Fotobook.book.drawFigure(el.mask, {
                    fill: 'white',
                    rx: el.rx,
                });
            }

            return Fotobook.book._mask_tpl.supplant(params);
        },
        removeMask($containers) {
            if (!($containers instanceof jQuery)) {
                $containers = $($containers);
            }
            $containers.find(".apply-mask").removeAttr("mask");
            $containers.find(".mask").remove();
        },
        removeFrame($containers) {
            if (!($containers instanceof jQuery)) {
                $containers = $($containers);
            }
            $containers.find(".frame").remove();
        },
        appendFrame($containers, frame) {
            if (!($containers instanceof jQuery)) {
                $containers = $($containers);
            }
            Fotobook.book.removeFrame($containers);
            $containers.find(".append-frame").each(function () {
                this.append(frame);
            });
        },
        appendBg(selector, bg) {
            $(Fotobook.book.pagesList).find(selector).find(".append-bg-content").html(bg);
            $(Fotobook.book.book).find(selector).find(".append-bg-content").html(Fotobook.replaceSmallImagePath(bg));
        },
        updateCaptionContent(id, content) {
            const $containers = $(Fotobook.book.getContainerSelector(id));
            const $caption = $containers.find('.caption');
            if (Number($caption.attr('data-type')) === Fotobook.CaptionType.RICH) {
                $caption.find(".text-content").html(content);
            } else {
                $caption.find(".text-content:not([contenteditable])").replaceWith(content);
            }
            Fotobook.book.markEmptyCaption($containers);
        },
        setImageCropData($img, data) {
            $img.add($img.siblings('.foto-image-cropping')).attr({
                x: ['-', (data.crop_cx || 50), '%'].join(''),
                y: ['-', (data.crop_cy || 50), '%'].join(''),
            }).filter("image").attr({
                "data-width": data.foto_width || 1,
                "data-height": data.foto_height || 1,
                "data-crop_cx": data.crop_cx || 50,
                "data-crop_cy": data.crop_cy || 50,
                "data-crop_width": data.crop_width || 100,
                "data-crop_height": data.crop_height || 100,
            });
        },
        setImageData($img, data) {
            $img.add($img.siblings('image.foto-image-cropping')).attr({
                'xlink:href': data.href || '',
            }).css(this.getFotoAngleVars(data?.angle ?? 0));
            Fotobook.book.setImageCropData($img, data);
        },
        _fotoClassRegexp: new RegExp(/^foto_\d+$/),

        setContainerImage(data) {
            const $cont = $(Fotobook.book.getContainerSelector(data.container_id));
            const $img = $cont.find(".foto-image");
            const oldImageId = $img[1].getAttribute("data-id"); // Обращение таким "[1]" образом требует пересмотра !!!

            $img.each(function () {
                const classes = Array.prototype.slice.call(this.classList);
                for (let i = 0, l = classes.length; i < l; i++) {
                    if (Fotobook.book._fotoClassRegexp.test(classes[i])) {
                        this.classList.remove(classes[i]);
                    }
                }
                if (data.foto_id) {
                    this.classList.add(`foto_${data.foto_id}`);
                }
                this.setAttribute('data-id', data.foto_id || '');
            });
            const isUploadingNow = data.foto_id ? Fotobook.import.isUploadingNow(Fotobook.ClipartType.FOTO, data.foto_id) : false;
            $cont
                .removeClass('preview')
                .toggleClass('empty', !data.foto_id)
                .toggleClass('ajax-tooltip', !data.foto_id)
                .toggleClass('uploading', isUploadingNow)
                .toggleClass('no-original', !!data.foto_id && !data.original_exists)
                .attr('data-qtip-selector', isUploadingNow ? 'photobook-tooltipText-noOriginalUploading' : '')
                .css(Fotobook.book.getContainerFotoAngleVars(data.foto_angle))
            ;
            Fotobook.book.setImageData($img, data);
            if (data.foto_id) {
                Fotobook.bottomPanel.fotosTab.selectImage(data.foto_id);
                Fotobook.bottomPanel.fotosTab.deselectImage(oldImageId);
                $img.attr('deselect-foto-id', data.foto_id);

                // перерисовываем только свернутую панель
                if (!Fotobook.store.getters['imagesPanel/opened']) {
                    Fotobook.store.dispatch('imagesPanel/draw');
                }
            } else {
                $cont.removeClass('low-quality-container');
                Fotobook.book.setImageData($img, {});
            }
            Fotobook.book.recalcContainer.call($cont);
        },
        setContainerImage_response(/** FotoContainer */ cont) {
            let data;
            /** @var {Foto} foto */
            const foto = cont.foto;
            if (foto?.id) {
                data = {
                    angle: foto.angle,
                    container_id: cont.id,
                    foto_angle: cont.foto_angle ?? 0,
                    foto_id: foto.id,
                    href: Fotobook.createStorageUrl(`${foto.preview_path}?version=${foto.version}`),
                    foto_width: foto.width,
                    foto_height: foto.height,
                    crop_cx: cont.crop_cx,
                    crop_cy: cont.crop_cy,
                    crop_width: cont.crop_width,
                    crop_height: cont.crop_height,
                    original_exists: foto.originalExists,
                };
            } else {
                data = {
                    container_id: cont.id,
                };
            }
            Fotobook.book.setContainerImage(data);
        },

        /**
         * Собирает и возвращает все ошибки страниц (пустые контейнеры, низкое качество фото и т.п.).
         * @returns {{
         *  'empty-cont': {count: *, text: string},
         *  'no-orig': {count: *, text: string},
         *  'low-quality': {count: *, text: string},
         *  others: {count: number, text: string}
         * }}
         */
        getPagesErrors() {
            const bgSpread = Fotobook.book.isBgSpread(this.find('.bg-content'));
            const errors = {
                'empty-cont': {
                    count: this.find('.foto-container.empty').length,
                    text: window.t('photobook-tooltipText-contWarning-empty'),
                },
                'no-orig': {
                    count: this.find('.foto-container.no-original').length,
                    text: window.t('photobook-tooltipText-contWarning-noOrig'),
                },
                'low-quality': {
                    count: this.find('.page-container.low-quality-container').length,
                    text: window.t('photobook-tooltipText-contWarning-lowQuality'),
                },
                others: {
                    count: 0,
                    text: window.t('photobook-tooltipText-contWarning-others'),
                },
            };
            let noOriginalBg = this.find('.bg-content.no-original').length;
            let lowQualityBg = this.find('.bg-content.low-quality-container').length;

            if (bgSpread) {
                if (noOriginalBg) {
                    noOriginalBg = 1;
                }
                if (lowQualityBg) {
                    lowQualityBg = 1;
                }
            }
            errors['no-orig'].count += noOriginalBg;
            errors['low-quality'].count += lowQualityBg;
            return errors;
        },

        /**
         * @todo переместить в провекрку качества проекта ?
         * @returns {number}
         */
        showCarouselWarnings() {
            const $warnings = this.find('.book-errors');
            const errors = Fotobook.book.getPagesErrors.call(this);

            // оверрайдим сообщение об ошибке конкретно для этого типа
            errors['empty-cont'].text = `${errors['empty-cont'].text}: ${errors['empty-cont'].count}`;

            let total = 0;
            let errorMessage = '';
            for (const i in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, i)) {
                    total += errors[i].count;
                    $warnings.find(`.cont-warning-${i}`).toggle(errors[i].count > 0).find('.warning-counter').text(errors[i].count);
                    if (errors[i].count > 0) {
                        errorMessage += `${errors[i].text}<br />`;
                    }
                }
            }

            const $carouselItem = this.closest('.carousel-item');

            // показываем только тултип о незаполненных контейнерах
            // только на свернутой панели и при влюченном отображении качества заполнения
            const showTooltip = !Fotobook.store.getters['pagesPanel/opened'] && total > 0;
            $carouselItem.toggleClass('ajax-tooltip', showTooltip)
                .attr('data-qtip-text', errorMessage.length ? errorMessage : null);

            if (!showTooltip) {
                $carouselItem.qtip('destroy');
            }

            this.toggleClass('has-errors', total > 0);
            return total;
        },

        _getImageCroppingData($img) {
            return {
                foto_id: $img.attr('data-id'),
                crop_cx: Math.abs(parseFloat($img.attr('data-crop_cx'))),
                crop_cy: Math.abs(parseFloat($img.attr('data-crop_cy'))),
                crop_width: Math.max(1, Math.min(100, parseFloat($img.attr('data-crop_width')))),
                crop_height: Math.max(1, Math.min(100, parseFloat($img.attr('data-crop_height')))),
            };
        },
        removeContainersSend($containers) {
            const params = {};
            $containers.each(function () {
                if (!this.classList.contains("bg-content")) {
                    const id = Number(this.getAttribute('data-id'));
                    if (id) {
                        params[id] = Fotobook.book.COMMAND_REMOVE;
                    }
                } else {
                    Fotobook.book.getSingleOrSpreadBg(this).find(".bg-content").each(function () {
                        const id = Number(this.getAttribute('data-id'));
                        if (id) {
                            params[id] = {
                                foto_id: 0,
                                background_id: 0,
                                mask_id: 0,
                            };
                        }
                    });
                }
            });
            return Fotobook.containers.changeContainerAttrs(params);
        },
        /**
         * Диалог подтверждения удаления контейнера
         *
         * @param $containers
         * @returns {*}
         */
        removeContainerConfirmation($containers) {
            const message = $containers.length > 1 ? 'photobook-js-removeSelectedContainers-dialogText' : Fotobook.book._removeContainerStings[Number($containers.attr('data-container-type'))];

            return Fotobook.dialog.confirm(window.t(message), {
                title: window.t('photobook-js-removeArtefactDialogTitle'),
                doNotAskKey: 'RemoveContainer',
                closeButtonAction: 'reject',
                open() {
                    //установить фокус на кнопке отмены
                    $(this).parent().find('.fotobook-dialogbutton-reject').focus();
                },
            });
        },
        closeAllEditors(ids) {
            const selector = Fotobook.book.getContainerSelector(ids);
            // noinspection CssInvalidPseudoSelector
            $(':fotobook-containerEditor').each(function () {
                const $this = $(this);
                if (!selector || $this.closest(selector).length) {
                    $this.containerEditor('destroy');
                }
            });
        },

        /**
         * получить подпись для страницы
         *
         * @todo добавить в регион поле "шаблон названия страницы", различные функции в компонентах удалить
         */
        getPrintPageNum(page) {
            var pagesDiff = parseInt(Fotobook.book.product.covers_count, 10) - 1,
                isNotSingleCover = parseInt(Fotobook.book.product.covers_count, 10) !== 1;

            if (!page.length) {
                return "";
            } else if (page.hasClass("cover")) {
                const isBackCover = parseInt(page.attr('data-page_num'), 10) === 0; // страница 0 обозначает заднюю обложку
                return window.t( isBackCover && isNotSingleCover ? "photobook-js-backCoverPN" : "photobook-js-frontCoverPN");
            } else if (page.hasClass("flyleaf-page")) {
                return window.t("photobook-js-flyleafPN") + " " + Math.abs(parseInt(page.attr("data-page_num"), 10));
            } else {
                return window.t("photobook-js-pagePN") + " " + (parseInt(page.attr("data-page_num"), 10) - pagesDiff);
            }
        },

        /**
         * Добавляем/удаляет тултип с итемов карусели.
         * @param {boolean} state
         */
        toggleCarouselItemTooltip(state) {
            const $carouselItems = $(`html.display-book-errors ${Fotobook.book.pagesList}`)
                .find('.carousel-item').toggleClass('ajax-tooltip');
            if (state) {
                $carouselItems.qtip();
            } else {
                $carouselItems.qtip('destroy');
            }
        },

        // afterPanelOpen() {
        //     // убираем тултип итемов карусели для расширенного меню
        //     self.toggleCarouselItemTooltip(false);
        // },

        // afterPanelClose() {
        //     // добавляем тултип итемов карусели для расширенного меню
        //     self.toggleCarouselItemTooltip(true);
        // },
    });

    // Пересчёт рамок для браузеров, не поддерживающих атрибут vector-effect='non-scaling-stroke'
    if (!Fotobook.book['vector-effect']) {
        $.extend(Fotobook.book, {
            recalcFigure_k() {
                const $box = $(this).closest('.page-container');

                return {
                    x: $box.width() / parseInt(this.getAttribute('data-width'), 10),
                    y: $box.height() / parseInt(this.getAttribute('data-height'), 10),
                };
            },
            recalcFigure_path() {
                var path = this.getAttribute('data-d').split(/\s+|\s*,\s*/),
                    d = [], cmd = null, last = null,
                    k = Fotobook.book.recalcFigure_k.call(this);

                for (let i = 0; i < path.length;) {
                    if (isNaN(path[i])) {
                        if (path[i] === 'M') {
                            cmd = (last === null) ? 'M' : 'L';
                            last = 'L';
                        } else if (path[i] === 'm') {
                            cmd = (last === null) ? 'm' : 'l';
                            last = 'l';
                        } else {
                            cmd = path[i];
                            last = cmd;
                        }
                        i++;
                    } else {
                        cmd = last;
                    }
                    d.push(cmd);

                    if ('Hh'.indexOf(cmd) !== -1) {
                        d.push(k.x * path[i]);
                        i++;
                    } else if ('Vv'.indexOf(cmd) !== -1) {
                        d.push(k.y * path[i]);
                        i++;
                    } else if ('MmLlTt'.indexOf(cmd) !== -1) {
                        d.push(k.x * path[i]);
                        d.push(k.y * path[i + 1]);
                        i += 2;
                    } else if ('QqSs'.indexOf(cmd) !== -1) {
                        d.push(k.x * path[i]);
                        d.push(k.y * path[i + 1]);
                        d.push(k.x * path[i + 2]);
                        d.push(k.y * path[i + 3]);
                        i += 4;
                    } else if ('Cc'.indexOf(cmd) !== -1) {
                        d.push(k.x * path[i]);
                        d.push(k.y * path[i + 1]);
                        d.push(k.x * path[i + 2]);
                        d.push(k.y * path[i + 3]);
                        d.push(k.x * path[i + 4]);
                        d.push(k.y * path[i + 5]);
                        i += 6;
                    } else if ('Aa'.indexOf(cmd) !== -1) {
                        d.push(k.x * path[i]);
                        d.push(k.y * path[i + 1]);
                        d.push(path[i + 2]);
                        d.push(path[i + 3]);
                        d.push(path[i + 4]);
                        d.push(k.x * path[i + 5]);
                        d.push(k.y * path[i + 6]);

                        i += 7;
                    }
                }
                d = d.join(' ');
                if (this.getAttribute('d') !== d) {
                    this.setAttribute('d', d);
                }
            },

            recalcFigure_polygon() {
                var r = [],
                    points = this.getAttribute('data-points').split(/\s+|\s*,\s*/),
                    k = Fotobook.book.recalcFigure_k.call(this);

                for (let i = 0, l = points.length; i < l; i += 2) {
                    r.push(k.x * points[i]);
                    r.push(k.y * points[i + 1]);
                }
                points = r.join(' ');
                if (this.getAttribute('points') !== points) {
                    this.setAttribute('points', points);
                }
            },

            recalcFigure() {
                const fun = `recalcFigure_${this.nodeName}`;
                if (Fotobook.book[fun] && Fotobook.book[fun].constructor === Function) {
                    Fotobook.book[fun].call(this);
                }
            },
            recalcCarouselFigures() {
                if (!Fotobook.book['vector-effect']) {
                    $(Fotobook.book.pagesList).find('.recalc-no-vector-effect').each(function () {
                        Fotobook.book.recalcFigure.call(this);
                    });
                }
            },
        });
    }

    $().entwine({
        selector: `${Fotobook.book.book} .page-container`,
        onmatch() {
            this.trigger(Fotobook.events.SETUP_BOOK_CONTAINER);
        },
    });

    $().entwine({
        selector: `${Fotobook.book.book} .bg .bounding-box`,
        onmatch: Fotobook.book.setupBgBoundingRect,
    });

    $().entwine({
        selector: '.filter',
        onmatch: Fotobook.book.recalcFilter,
        onunmatch: Fotobook.book.onRemoveFilter,
    });

    $().entwine({
        selector: '.text-container.text-shadow',
        onmatch: Fotobook.book.recalcTextShadow,
    });

    // Почему так - см комментарий к функции getFlipAttrs
    // указываем именно артефакт, чтобы не срабатывало на группах, в будущем может понадобиться ещё для фотоконтейнеров
    $().entwine({
        selector: '.artefact-container:not(.flipx):not(.flipy)',
        onmatch() {
            Fotobook.book.recalcFlip.call(this, false, false);
        },
    });
    $().entwine({
        selector: '.page-container.flipx:not(.flipy)',
        onmatch() {
            Fotobook.book.recalcFlip.call(this, true, false);
        },
    });
    $().entwine({
        selector: '.page-container.flipy:not(.flipx)',
        onmatch() {
            Fotobook.book.recalcFlip.call(this, false, true);
        },
    });
    $().entwine({
        selector: '.page-container.flipy.flipx',
        onmatch() {
            Fotobook.book.recalcFlip.call(this, true, true);
        },
    });

    // При появлении/удалении фото в фотоконтейнере производим пометку использованных фото в списке фотографий
    $().entwine({
        selector: `${Fotobook.book.pagesList} .foto-image:not([data-id=""])`,
        onmatch() {
            // стартует при загрузке раньше чем успевают отрисоваться фотки на фотопанели
            // пересмотреть !
            clearTimeout(self.imagesUpdateTimer);
            self.imagesUpdateTimer = setTimeout(() => Fotobook.bottomPanel.fotosTab.markUsedPhotos(), 300);
        },
        onunmatch() {
            const deselectFotoId = this.attr('deselect-foto-id');
            Fotobook.bottomPanel.fotosTab.deselectImage(deselectFotoId);
            Fotobook.bottomPanel.fotosTab.rebuild2Lines(deselectFotoId, Fotobook.bottomPanel.actionRemove);
            //Fotobook.store.dispatch('imagesPanel/draw'); // creates too many requests
            this.removeData('deselect-foto-id');
        },
    });

    // При появлении/удалении фото на фоне производим пометку использованных фото в списке фотографий
    $().entwine({
        selector: `${Fotobook.book.pagesList} .bg-clipart-foto`,
        onmatch() {
            Fotobook.bottomPanel.fotosTab.selectImage(this.attr('data-id'));
            Fotobook.bottomPanel.fotosTab.rebuild2Lines(this.attr('data-id'), Fotobook.bottomPanel.actionAdd);
        },
        onunmatch() {
            Fotobook.bottomPanel.fotosTab.deselectImage(this.attr('data-id'));
            Fotobook.bottomPanel.fotosTab.rebuild2Lines(this.attr('data-id'), Fotobook.bottomPanel.actionRemove);
        },
    });

    // подсчёт проблемных контейнеров в книге и отображение их
    $().entwine({
        selector: `html.display-book-errors ${Fotobook.book.pagesList}`,
        onmatch() {
            let total = 0;
            this.find('.carousel-item').each(function () {
                total += Fotobook.book.showCarouselWarnings.call($(this));
            });
            if (!total) {
                Fotobook.notification.showSuccess(window.t('photobook-js-projectIsCorrect'));
            } else {
                $('html').addClass('show-count-errors');
            }
        },

        onunmatch() {
            this.find('.carousel-item').removeClass('has-errors ajax-tooltip')
                .qtip('destroy');
            $('html').removeClass('show-count-errors');
        },
    });

    $(document)
        .on(Fotobook.events.SETUP_BOOK_CONTAINER, '.page-container', Fotobook.book.setupBookContainer)
        .on('fotoupdate.wizardbook', `${Fotobook.book.pagesList} image.foto-image:not([data-id=""])`, function () {
            const foto = $(this);
            const oldId = foto.attr('deselect-foto-id');
            foto.attr('deselect-foto-id', foto.attr('data-id'));
            Fotobook.bottomPanel.fotosTab.selectImage(foto.attr('data-id'));
            Fotobook.bottomPanel.fotosTab.deselectImage(oldId);
        });


    /**
     * Ленивая инициализация draggable на элементах бокового меню (по наведению мыши)
     */
    (function ($) {
        var draggable_params = {
                appendTo: ".site_content",
                containment: ".site_content",
                helper: "clone",
                revert: "invalid",
                scroll: false,
                zIndex: Fotobook.book.zindex.dragging,
                start(event, ui) { // центрирует курсор любого перетаскиваемого элемента
                    $(this).draggable('instance').offset.click = {
                        left: Math.floor(ui.helper.width() / 2),
                        top: Math.floor(ui.helper.height() / 2),
                    };
                },
            },
            old_mouseCapture = $.ui.draggable.prototype._mouseCapture;
        $.ui.draggable.prototype._mouseCapture = function (event) {
            if ($(event.target).closest(".text-content,.redactor-general").length) {
                return false;
            }
            return old_mouseCapture.call(this, event);
        };

        $(document)
            .on('mouseover', '.collage-layout', function (event) {
                const $this = $(this);
                const draggable = $this.data('ui-draggable');
                if (Fotobook.store.getters['OnlineEditor/editMode'].code !== Fotobook.EditModeCode.INSTANT) {
                    if (!draggable) {
                        $this.draggable($.extend({}, draggable_params, {
                            cursorAt: {
                                left: 37,
                                top: 22,
                            },
                        }));
                    }
                } else if (draggable) {
                    draggable.destroy();
                }
            })
            .on("mouseover.wizardbook", ".cover-layout-left-menu.cover-layout", function (event) {
                const $this = $(this);
                if (!$this.data('ui-draggable')) {
                    $this.draggable($.extend({}, draggable_params, {
                        cursorAt: {
                            left: 37,
                            top: 22,
                        },
                    }));
                }
            })
            .on("mouseover.wizardbook", ".album-fotos .album-image-draggable", function (event) {
                var $this = $(this),
                    draggable = $this.data("ui-draggable"),
                    img, w, h;

                if (draggable || $this.hasClass("no-original") && !$this.hasClass("uploading")) {
                    return;
                }

                img = $this.find(".album_image");
                w = img.width();
                h = img.height();
                $this.draggable($.extend({}, draggable_params, {
                    helper() {
                        return img.clone().css({
                            width: w,
                            height: h,
                        });
                    },
                    start(event, ui) {
                        $(Fotobook.book.book).addClass("image-drag");
                        $("html").addClass("foto-containers-tolerance");
                    },
                    stop() {
                        $(Fotobook.book.book).removeClass("image-drag");
                        $("html").removeClass("foto-containers-tolerance");
                    },
                }));
            });
    })(jQuery);

    (function ($) {
        $(document)
            .on("mouseout.wizardbook", ".cropping-handle", function (e) {
                $(".crop-handle-over").removeClass("crop-handle-over");
            })
            .on("mouseover.wizardbook", ".bg .cropping-handle", function (e) {
                const $handle = $(this);

                Fotobook.book.getSingleOrSpreadBg($handle).find(".bg-content").addClass("crop-handle-over");
                if (!$handle.is(":ui-draggable")) {
                    $handle.draggable({
                        helper() {
                            return $("<div></div>");
                        },
                        appendTo: "body",
                        scroll: false,
                        start(event, ui) {
                            var $this = $(this),
                                $bg = $this.closest(".bg"),
                                $bbox = $bg.find(".bounding-box"),
                                bgbox = $bbox[0].getBoundingClientRect(),
                                $img = $bg.find(".bg-clipart-foto"),
                                imgbox = $img[0].getBoundingClientRect(),
                                $imgs = Fotobook.book.getSingleOrSpreadBg($bg).find(".bg-clipart-foto");

                            $imgs.each(function () {
                                $(this)
                                    .data("cropping-orig-x", this.x.baseVal.value)
                                    .data("cropping-orig-y", this.y.baseVal.value);
                            });
                            ui.helper.data("cropping", {
                                maxdx: bgbox.left - imgbox.left,
                                mindx: bgbox.right - imgbox.right,
                                maxdy: bgbox.top - imgbox.top,
                                mindy: bgbox.bottom - imgbox.bottom,
                                imgs: $imgs,
                            });
                            $("html").add($imgs.closest(".bg-content")).addClass("crop-dragging");
                        },
                        drag(event, ui) {
                            var data = ui.helper.data("cropping"),
                                dx = Math.min(data.maxdx, Math.max(data.mindx, ui.position.left - ui.originalPosition.left)),
                                dy = Math.min(data.maxdy, Math.max(data.mindy, ui.position.top - ui.originalPosition.top));

                            data.imgs.each(function () {
                                const $this = $(this);
                                this.setAttribute("x", Fotobook.book.pxToEm.call($this, $this.data("cropping-orig-x") + dx));
                                this.setAttribute("y", Fotobook.book.pxToEm.call($this, $this.data("cropping-orig-y") + dy));
                            });
                        },
                        stop(event, ui) {
                            var $this = $(this),
                                $bg = $this.closest(".bg"),
                                $bbox = $bg.find(".bounding-box"),
                                bgbox = $bbox[0].getBoundingClientRect(),
                                $img = $bg.find(".bg-clipart-foto"),
                                imgbox = $img[0].getBoundingClientRect(),
                                bg_cx = (bgbox.left + bgbox.right) / 2,
                                bg_cy = (bgbox.top + bgbox.bottom) / 2,
                                crop_cx = 100 * (bg_cx - imgbox.left) / imgbox.width,
                                crop_cy = 100 * (bg_cy - imgbox.top) / imgbox.height,
                                $img2 = Fotobook.book.getAdjacentPage($bg).find(".bg-clipart-foto-half"),
                                params = {};

                            if ($img2.length && $img.hasClass("bg-clipart-foto-half") && ($img.attr("data-id") == $img2.attr("data-id"))) {
                                $img = $img.add($img2);
                            }

                            $img.each(function () {
                                const $this = $(this);
                                params[$this.closest(".bg-content").attr("data-id")] = {
                                    crop_cx,
                                    crop_cy,
                                };
                            });
                            Fotobook.containers.changeContainerAttrs(params);
                            ui.helper.removeData("cropping");
                            $(".crop-dragging").removeClass("crop-dragging");
                        },
                    });
                }
            })
        ;
    })(jQuery);

    $.extend(Fotobook.book, {
        getContainerFotos(ids) {
            return $(".pages-wrapper").find(".foto_" + ids.join(",.foto_"));
        },
        getBgFotos(ids) {
            return $(".bg-clipart-foto[data-id=" + ids.join("],.bg-clipart-foto[data-id=") + "]");
        },
    });

    $(document)
        .on(Fotobook.events.ORIGINAL_UPLOAD_START, (event, data) => {
            Fotobook.book.getContainerFotos(data.ids).closest('.page-container').addClass('uploading');
            Fotobook.book.getBgFotos(data.ids).closest('.bg-content').addClass('uploading').closest('.bg-wrapper').addClass('uploading');
        })
        .on(Fotobook.events.ORIGINAL_UPLOAD_END, (event, data) => {
            if (data.success.length) {
                Fotobook.book.getContainerFotos(data.success).closest('.page-container').removeClass('uploading no-original');
                Fotobook.book.getBgFotos(data.success).closest('.bg-content').removeClass('uploading no-original').closest('.bg-wrapper').removeClass('uploading no-original');
            }

            if (data.fail.length) {
                Fotobook.book.getContainerFotos(data.fail).closest('.page-container').removeClass('uploading');
                Fotobook.book.getBgFotos(data.fail).closest('.bg-content').removeClass('uploading').closest('.bg-wrapper').removeClass('uploading');
            }
        })

        // Если нужно делать стили, зависящие от состояния кнопок, классы добавлять здесь
        .on('keydown.wizardbook', (e) => {
            if (e.ctrlKey) {
                $('html').addClass('ctrl-pressed');
            }
        })
        .on('keyup', (e) => {
            if (!e.ctrlKey) {
                $('html').removeClass('ctrl-pressed');
            }
        })

        // события листалки
        .on('bookletchange', (event, data) => {
            // завершилось перелистывание страницы
            $('#book-preview .booklet-navigation').data('isturningpage', false);
        })
        .on('bookletstart', (event, data) => {
            // началось перелистывание страницы
            $('#book-preview .booklet-navigation').data('isturningpage', true);
        })


        .on(Fotobook.events.AJAX_DONE, (event, result, response) => {
            if (!response || !response.data) {
                return;
            }
            if (response.data.project) {
                self.setProjectInfo(response.data.project);
            }

            if (response.data.state && response.data.state.prices) {
                Fotobook.book.prices = response.data.state.prices;
            }

            self.updateUndoRedoButtons(response.data);
        })
    ;
})();

Fotobook.Vue.observable(Fotobook.book); // todo временно!!! перенести во vuex
